export default {
  attributes: {
    invoicing_firm: {
      invoicing_firm_validated: 'Invoicing Firm validated',
      select_condition: 'Select a condition',
      no_permission_to_create: 'No Permission to create',
      invoice_number: 'Last invoice number',
      credit_note_number: 'Last invoice number',
      current_credit_note_number_voucher: 'Last credit note num. nota Voucher',
      current_invoice_number_voucher: 'Last invoice num. Voucher',
      fiscal_info: 'Fiscal Info',
      general_info: 'General Info',
      last_credit_note_number: 'Last credit note numbers',
      last_credit_note_numbers: 'Latest credit note numbers',
      last_invoice_number: 'Last invoice numbers',
      last_invoice_numbers: 'Latest invoice numbers',
      use_account_data: 'Use account data',
      verify_by_support_successfully: 'Verification by support successful',
      invoicing_invoicing_configuration_id: 'Configuration',
      argentina: {
        invoicing_invoicing_configuration_id: 'Configuration',
        invoicing_firm_validated: 'Invoicing Firm validated',
        verify_webservice_connection: 'Verify webservice connection',
        upload_afip_certificate: 'Upload the certificate issued by AFIP',
        no_electronic_invoice: 'No info to show',
        certificate_expiration_date: ' Certificate expiration',
        afip_doc: 'Documentation AFIP Service',
        conf_afip_step_1: 'First step: Download request file for generate AFIP certificate',
        conf_afip_step_2:
          'Second step: Upload the certificate generated by AFIP. Whit this, it will generate electronic invoices.',
        conf_afip_step_3: 'Third step: Check certificate if is valid.',
        request_afip: 'Request AFIP',
        check_webservice: 'Check webservice',
        banelco_code: 'Company number assigned by Banelco for PagoMisCuentas',
        afip_service: 'AFIP Service',
        electronic_validated: 'Electronic Invoicing Firm validated',
        electronic_unvalidated: 'Unverified electronic invoicing firm',
        current_credit_note_number_voucher_a: 'Argentina (A)',
        current_credit_note_number_voucher_b: 'Argentina (B)',
        current_credit_note_number_voucher_c: 'Argentina (C)',
        current_invoice_number_argentina_a: 'Argentina (A)',
        current_invoice_number_argentina_b: 'Argentina (B)',
        current_invoice_number_argentina_c: 'Argentina (C)',
        registered_vat_payer: 'Registered vat payer',
        self_employed_taxpayer: 'Self employed taxpayer',
        taxpayer_identification_number: 'CUIT/CUIL',
        upload_certificate: 'Upload certificate'
      },
      colombia: {
        invoicing_invoicing_configuration_id: 'Configuration',
        invoice_provider: 'Provider',
        resolution_date: 'Resolution date',
        resolution_number: 'Resolution number',
        current_selector: 'Use this numbering as the current one?',
        service_password: 'Password Token',
        service_url: 'Endpoint (FactoryHKA)',
        service_user: 'Business Token',
        taxpayer_identification_number: 'CC/CE/NIT',
        use_pdfs_from_service: 'Send FactoryHKA PDF',
        vat_condition: 'Regime',
        electronic_provider: 'Electronic Provider (account data)',
        use_account_data: 'Use account data',
        sale_point_town: 'Municipality',
        electronic_validated: 'Electronic Invoicing Firm validated',
        electronic_unvalidated: 'Unverified electronic invoicing firm',
        no_retentions_for_periodic: 'The periodic invoices will be generated WITHOUT retentions.',
        create_new_numeration: 'Create new numeration',
        in_use: 'Using',
        expire_at: 'Expiration date',
        credit_notes: 'Credit Notes',
        old_pools: 'Previus numeration',
        electronic_verify: 'Verify electronic account',
        warning_tab_invoice: 'You will not be able to invoice without authorized numbers',
        warning_tab_credit_note: 'You will not be able to cancel invoices without numbers',
        colombia_factory_hka: 'Factory HKA',
        hka_documentation: 'Factory HKA documentation',
        colombia_factory_hka_configuration: 'Factory HKA Configuration',
        colombia_siigo_configuration: 'Siigo Configuration',
        colombia_siigo: 'Siigo',
        siigo: {
          siigo_dgo_product: 'Product/Service (DGO)',
          siigo_dgo_identification: 'Identification (DGO)',
          activate_net_amount_text: 'To review this configuration you can go to',
          use_net_amount: 'Using billing amounts as net values',
          configurate_siigo: 'Configurate Siigo',
          service_password: 'Access Key',
          service_user: 'User API',
          sigo_documentation: 'Siigo documentation',
          siigo_alert_message:
            'To bill with Siigo, you must use the billing amounts as net values. To review this setting you can go to',
          siigo_no_retentions: 'The invoices will be generated WITHOUT retentions.',
          siigo_configuration_successful_updated: 'Siigo has been successfully configured'
        }
      },
      peru: {
        invoicing_invoicing_configuration_id: 'Configuration',
        nubefact_alert_message:
          'To bill with NubeFacT, you must use the billing amounts as net values. To review this setting please contact with support',
        electronic_unvalidated: 'Razón Social electrónica no verificada',
        electronic_validated: 'Cuenta electrónica validada',
        final_consumer_invoice_serial_peru: 'Prefix ticket',
        first_final_consumer_invoice_number: 'Final consumer invoice',
        first_final_consumer_invoice_number_hint:
          'Place the number of the last invoice in the series, if it is a new series, place 1',
        first_invoice_number: 'First invoice number',
        first_invoice_number_hint: 'Place the number of the last invoice in the series, if it is a new series, place 1',
        general_regime: 'General Regime',
        invoice_serial_peru: 'Prefix invoice',
        nubefact: 'NubeFacT',
        service_password: 'Password',
        service_url: 'Endpoint (ID)',
        taxpayer_identification_number: 'RUC',
        use_account_data: 'Use account data',
        generic_general_regime: 'General Regime',
        mype_regime: 'Regime MYPE',
        new_unique_simplified_regime: 'New Unique Simplified Regime (NRUS)',
        peru_next_invoice_number: 'Sales Invoice',
        peru_next_invoice_credit_note_number: 'Sales Invoice Credit Note',
        peru_next_final_consumer_invoice_number: 'Bill of Sale',
        peru_next_final_consumer_invoice_credit_note_number: 'Bill of Sale Credit Note',
        not_generated_message: 'If you are already in production mode with NubeFacT, do not press this button',
        generating_message: 'Invoices are being generated',
        generated_message: 'Invoices have been generated, please contact NubeFacT',
        nubefact_form_message:
          'The numbering will start from 1 to start using NubeFacT, in case you already have NubeFacT in production please contact support to configure the numbering'
      },
      ecuador: {
        accounting_description: 'Obliged to keep accounting records',
        billing_regime: 'Billing Regime',
        certificate_updated: 'The Certificate and Password were updated',
        conf_fiscal_step_1: 'Obtain certificate',
        conf_fiscal_step_2: 'Upload Certificate',
        contifico: {
          configurate_contifico: 'Configurate',
          contifico_configuration_successful_updated: 'Contifico has been successfully configured',
          contifico_ice_product_id: 'Product & Service (ICE)',
          contifico_iva_product_id: 'Product & Service (IVA)',
          validate_invoice_provider_contifico: 'Validate Contifico account'
        },
        ecuador_contifico: 'Contifico',
        ecuador_contifico_configuration: 'Contifico Configuration',
        ecuador_sri: 'SRI',
        electronic_provider: 'Electronic Provider',
        electronic_unvalidated: 'Unverified electronic invoicing firm',
        electronic_validated: 'Electronic Invoicing Firm validated',
        fiscal_doc: 'View documentation',
        fiscal_info: 'Fiscal Information',
        fiscal_step_1: 'Obtain certificate (.p12). You must manage it with one of the authorized entities',
        fiscal_step_2:
          'Upload the certificate (.p12). Since with this certificate the electronic invoices will be authorized with the SRI',
        fiscal_title: 'Register certificate',
        general_regime: 'General regime',
        invoice_provider: 'Provider',
        invoicing_invoicing_configuration_id: 'Configuration',
        ecuador_first_credit_note: 'First credit note number',
        ecuador_first_invoice: 'First invoice number',
        principal_activity: 'Business Name',
        pyme_description: 'PYMES regime',
        retention_agent_number: 'Retention Agent Resolution No.',
        rimpe_description: 'RIMPE regime',
        sale_point: 'Issue Point',
        sale_point_address: 'Merchant Address',
        sale_point_code: 'Establishment Code',
        sell_invoice: 'Sales Invoice',
        sell_invoice_hint: 'Only the number, without prefixes (xxx-xxx-000000000)',
        service_password: 'API Key',
        service_user: 'API Token',
        taxpayer: 'Taxpayer',
        taxpayer_identification_number: 'RUC',
        upload_certificate: 'Subit .p12'
      },
      mexico: {
        invoicing_invoicing_configuration_id: 'Configuration',
        general_regime: 'General Regime of Legal Persons Law',
        taxpayer_identification_number: 'RFC',
        vat_condition: 'Regime',
        update_production_credentials: 'Complete the data with the information received from Facturación Modern.',
        generate_testing_dataset: 'Generation of the test data set to be sent to Facturación Modern.',
        verify_credentials: 'Verification connection to Facturación Moderna',
        modern_step_1: 'Generate and download dataset',
        modern_step_2: 'Enable production credentials',
        modern_step_3: 'Verify credentials',
        generate_dataset: 'Generate dataset',
        update_dataset: 'Update data',
        use_account_data: 'Use account data',
        fiscal_doc: 'See guide',
        modern_invoicing_title: 'Configure Modern Invoicing',
        service_user: 'User',
        service_password: 'Password',
        service_url: 'Endpoint',
        fm_wsdl: 'Wsdl',
        fm_certificate_number: 'Certificate Number',
        fm_logo: 'Logo ID',
        use_pdfs_from_service: 'Use Modern Invoicing Pdf',
        fiscal_info: 'Invoicing',
        modern_info: 'Modern Invoicing (account data)'
      }
    },
    acs_server: {
      name: 'Name',
      host: 'Host',
      port: 'Port',
      user: 'User',
      password: 'Password',
      brand: 'Brand'
    },
    address: {
      client_netmask: 'Client Netmask',
      dns_one: 'First DNS',
      dns_two: 'Second DNS',
      free_ip_prefix: '[Free]',
      gateway: 'Gateway',
      host: 'Host',
      ip: 'IP address',
      nat_pool_ip_prefix: '[NAT pool]',
      netmask: 'Netmask',
      use_in_nat_pool: 'Use in NAT pool'
    },
    agent: {
      linked_to_wisprobox: 'Linked to WisproBox',
      create_new_agent: 'Create new Box',
      acs_access_url: 'Access',
      select_acs: 'Select ACS',
      select_agents: 'Select Agents',
      token: {
        hint: 'Token is required to link WisproBox'
      }
    },
    audit: {
      auditable_id: 'Model ID',
      auditable_type: 'Model',
      changes: 'Changes applied',
      created_at_eq_date: 'Created at',
      event_eq_any: 'Action',
      event_eq_any_create: 'Create',
      event_eq_any_delete: 'Delete',
      event_eq_any_update: 'Update',
      item_id: 'ID',
      item_id_eq: 'ID',
      not_found: 'Record not found',
      select_advanced: 'Choose an option',
      whodunnit_eq: 'User Responsible'
    },
    avoid_balancing_host: {
      provider: 'Provider'
    },
    bmu_version: {
      version_changes: 'Changes made on version'
    },
    client: {
      at_least_invoicing_client_delinquent: 'At least a delinquent contract',
      export_only_filtered: 'Export only filtered',
      all_invalid_mobiles_filtered: 'All invalid mobiles filtered',
      client_id: 'ID Client', //Se usa para buscador hablar con Pablo o Charly
      without_payment_gateways_filter: 'Without payment gateways',
      with_payment_gateways: 'Payment gateways',
      invoices_filter_title: 'Clients (Billing)',
      clients_filter_title: 'Clients',
      devices_using_internet_alert_mobile_app: 'Devices using Internet Alert mobile App:',
      physical: 'Natural person',
      other: 'Other',
      juridic: 'Legal person',
      paid_unidentified: 'Paid - Unidentified',
      unpaid: 'Unpaid',
      paid: 'Paid',
      draft: 'Draft',
      void: 'Void',
      invoice: 'Invoice',
      additional_one: 'Additional info',
      additional_two: 'Additional info 2',
      available_credit_on_account: 'Available credit on account',
      balance_ca: 'Balance C/A',
      barcode_siro: 'Barcode',
      concept: {
        mexico: 'CFDI use'
      },
      contracts_state_eq_any_title: 'Contract State',
      contracts_state_eq_any_alerted: 'Alerted',
      contracts_state_eq_any_degraded: 'Degraded',
      contracts_state_eq_any_disabled: 'Disabled',
      contracts_state_eq_any_enabled: 'Enabled',
      delinquent_contracts_filter_eq_title: 'Invoicing State',
      delinquent_contracts_filter_delinquent: 'With delinquent contracts',
      delinquent_contracts_filter_up_to_date: 'Without delinquent contracts',
      create_new_client: 'Create new Client',
      custom_id: 'Customizable identifier',
      device_token: 'Device token',
      devices_filter_both: 'Both',
      devices_filter_has_devices: 'With device',
      devices_filter_no_devices: 'Without device',
      digital_barcode: 'Digital barcode',
      generate_the_invoice_the_days: 'Generate the invoice the days',
      has_contracts_filter_both: 'Both',
      associated_contracts: 'Associated contract:',
      has_contracts_filter_with: 'With contract',
      has_contracts_filter_without: 'Without contract',
      invoicing_client_additional_one_null_both: 'Both',
      invoicing_client_additional_one_null_no_present: 'No Present',
      invoicing_client_additional_one_null_present: 'Present',
      invoicing_client_additional_one_null_title: 'Additional information',
      invoicing_client_authorize_invoice_after_paid_eq_both: 'Both',
      invoicing_client_authorize_invoice_after_paid_eq_false: 'Disabled',
      invoicing_client_authorize_invoice_after_paid_eq_title: 'Inform after pagar',
      invoicing_client_authorize_invoice_after_paid_eq_true: 'Enabled',
      invoicing_client_automatic_state_eq_both: 'Both',
      invoicing_client_automatic_state_eq_false: 'Disabled',
      invoicing_client_automatic_state_eq_title: 'Automatic State',
      invoicing_client_automatic_state_eq_true: 'Enabled',
      invoicing_client_invoicing_enabled_eq_both: 'Both',
      invoicing_client_invoicing_enabled_eq_false: 'Disabled',
      invoicing_client_invoicing_enabled_eq_title: 'Invoicing',
      invoicing_client_invoicing_enabled_eq_true: 'Enabled',
      last_number_informed_in_siro: 'Last number informed in Siro',
      last_number_informed_to_siro: 'Last number informed to SIRO',
      link_payments_code: 'LinkPayments code',
      link_payments_siro: 'Electronic Payment Code',
      max_download: 'Máx. Download',
      max_upload: 'Máx. Upload',
      name: 'Name',
      name_lastname: 'Name and Lastname',
      paranoia_active: 'Actives',
      paranoia_both: 'Both',
      paranoia_deleted: 'Deleted',
      paranoia_filter: 'Client status',
      payment_gateways: {
        pichincha: {
          form: {
            account_debit_kind: 'Account type',
            client_gateway_id: 'ID of the account holder',
            account_name: "Account holder's name",
            account_number: 'Account number',
            mi_vecino_hint:
              'Mi Vecino: The customer must pay their bill at Banco Pichincha’s sales points using their ID or RUC.',
            automatic_debit_hint:
              'Automatic Debit: The customer authorizes their bill to be automatically debited from their bank account.',
            current_account: 'Current account',
            saving_account: 'Saving account',
            title: 'Account information for automatic debit',
            unique_pichincha_code: 'Unique Pichincha code'
          }
        }
      },
      pending_invoices_filter_both: 'Both',
      pending_invoices_filter_title: 'Pending Invoce',
      pending_invoices_filter_without: 'Without pending invoice',
      phone_mobile: 'Mobile phone number',
      phone_mobile_verified_eq_both: 'Both',
      phone_mobile_verified_eq_enable: 'Verified',
      phone_mobile_verified_eq_dissable: 'Not verified',
      phone_mobile_verified_eq_with_contracts: 'Not verified',
      placeholder_basic_search:
        'You can search by: Name, Email address, Phone number, National identification number, Mobile phone number, Address, Customizable identifier, IP address',
      reference: 'Reference',
      select_client: 'You must select at least one customer',
      start_invoicing_day_gteq: 'Invoice day (from)',
      start_invoicing_day_lteq: 'Invoice day (to)',
      status_type: 'Status (Type)',
      with_credit_both: 'Both',
      with_credit_title: 'Credit',
      with_credit_filter_with: 'Clients with credit',
      with_credit_without: 'Clients without credit',
      with_invoicing_errors_both: 'Both',
      with_invoicing_errors_filter_with: 'With invoicing errors',
      with_invoicing_errors_without: 'Without errors',
      with_pending_invoices_with: 'With pending invoice',
      deactivated: 'Removed',
      details: 'Observations',
      email: 'Email address',
      external_client_number: 'Client Number',
      id: 'ID',
      invoicing_frecuency: {
        ['1']: 'Monthly',
        ['2']: 'Bimonthly',
        ['3']: 'Every three months',
        ['4']: 'Quarterly',
        ['6']: 'Semiannual ',
        ['12']: 'Annual'
      },
      national_identification_number: 'National identification number',
      password_confirmation: 'Confirmation',
      phone: 'Phone number',
      phone_mobile_verified: 'Verified mobile phone',
      state: 'Province/State/Region',
      taxpayer_identification_number: 'Taxpayer identificacion number',
      zoneables_zone_ids: 'Zone'
    },
    cloud_license: {
      button_enable_internal_use: 'Enable internal use',
      button_disable_internal_use: 'Disable internal use',
      acs_license: {
        cloud_license_id: 'Cloud license ID',
        installation_price: 'Installation price',
        installation_price_hint: 'The client is charged once',
        price: 'ACS price',
        summary: 'Summary'
      },
      approve: 'Approved',
      authorization_expired: 'Autorization expired',
      authorized: 'Settlement autorized',
      cardholder_name: 'Cardholder',
      changes_history: 'Recent changes',
      current_billing_cycle: 'Current billing cycle',
      current_number_of_clients: 'Current number of clients',
      decline: 'Declined',
      discount_expiration_date: 'Discount expiration date',
      discount_used: 'Finished discount',
      expiration_date: 'Expiration date',
      extended_until: 'Subscription extension',
      fail: 'Failed',
      failed: 'Failed',
      gateway_rejected: 'Settlement rejected',
      has_trial: 'Days free',
      hola_suite: {
        annual: 'Annual',
        annual_price: 'Annual price',
        channels: 'items (Chat GPT, ChatWeb, Instagram, Messenger, Pabx, Telegram, Web)',
        chat_gpt_enabled: 'Chat GPT',
        chat_gpt_price: 'Price (Chat GPT)',
        chat_web_enabled: 'Chat Web',
        chat_web_price: 'Price (Web Chat)',
        cloud_service: 'Cloud',
        cloud_service_price: 'Price (Cloud)',
        extra_accesses: 'Extra accesses',
        extra_accesses_price: 'Extra accesses_price',
        extra_accesses_price_hint: 'The price is for each access',
        gupshup: 'Gupshup',
        hello_suite: 'Hola Suite',
        hint_price: 'Hola license + Basic hosting + Whatsapp + 3 Accesses',
        instagram_enabled: 'Instagram',
        instagram_price: 'Price (Instagram)',
        installation: 'Installation',
        installation_price: 'Installation price',
        installation_price_hint: 'The client is charged once',
        kind_whatsapp_api: 'WhatsApp API',
        license_hola: 'License',
        messenger_enabled: 'Messenger',
        messenger_price: 'Price (Messenger)',
        monthly: 'Monthly',
        monthly_price: 'Monthly price',
        next_due_date: 'Next due date',
        pabx_enabled: 'PABX',
        pabx_price: 'Price (PABX)',
        partner: 'Partner',
        price: 'Hola Suite price',
        price_with_discount: 'Price with discount',
        serial_number: 'Serial number',
        summary: 'Summary',
        telegram_enabled: 'Telegram',
        telegram_price: 'Price (Telegram)',
        web_enabled: 'Web',
        web_price: 'Price (Web)',
        whatsapp_enabled: 'WhatsApp',
        whatsapp_price: 'Price (WhatsApp)',
        whatsapp_quantity: 'Number of WhatsApp accounts',
        token: 'TOKEN',
        url: 'URL',
        url_hint: `Valid URL: https://example.com`
      },
      input_installation_price: {
        hint: 'The client is charged once',
        name: 'Installation price'
      },
      installation_price: 'Installation price',
      invoices: {
        status: {
          draft: 'Draft',
          open: 'Unpaid',
          paid: 'Paid',
          uncollectible: 'Uncollectible',
          void: 'Void'
        }
      },
      last_4: 'Last 4 digits',
      license_type: 'Subscription',
      licenses: {
        basic: 'BASIC',
        pro: 'PRO',
        yarly_pro: 'PRO (Annual)',
        yearly_basic: 'BASIC (Annual)'
      },
      next_billing_date: 'Next billing date',
      no_more_discount: 'No more discount',
      paid_until: 'Paid until',
      pass: 'Passed',
      past_due: 'Past due',
      payment_method_token: 'Payment method',
      price_with_discount: 'Price with discount',
      pro: 'Pro',
      processor_declined: 'Settlement declined by processor',
      remaining_days_free: 'Remaining days free',
      remaining_months_discount: 'Remaining months with discount',
      review: 'Reviewed',
      settled: 'Settled',
      settlement_declined: 'Settlement declined',
      settlement_pending: 'Settlement pending',
      settling: 'Settling',
      statuses: {
        active: 'Active',
        blocked: 'Blocked',
        canceled: 'Canceled',
        failed: 'Failed',
        incomplete_expired: 'Expired',
        new_user: 'New user',
        past_due: 'Past due',
        trialing: 'Trialing',
        unpaid: 'Unpaid'
      },
      submitted_for_settlement: 'Submitted for settlement',
      succeeded: 'Success',
      total_clients: 'Total contracts',
      transaction_details: 'Transaction details',
      vendor_status: 'Vendor status',
      voided: 'Settlement voided'
    },
    concept: {
      mexico: {
        commodity: 'G01 - Acquisition of merchandise',
        returns_discounts_bonuses: 'G02 - Returns, discounts or bonuses',
        general_expenses: 'G03 - General expenses',
        buildings: 'I01 - Buildings',
        furniture_and_office_equipment_for_investments: 'I02 - Furniture and office equipment for investments',
        transportation_equipment: 'I03 - Transportation equipment',
        computer_equipment_and_accessories: 'I04 - Computer equipment and accessories',
        craps_dies_molds_matrixes_and_tooling: 'I05 - Craps dies molds matrixes and tooling',
        telephone_communications: 'I06 - Telephone communications',
        satellite_communications: 'I07 - Satellite communications',
        other_machinery_and_equipment: 'I08 - Other machinery and equipment',
        medical_fee_dental_and_hospital_expenses: 'D01 - Medical fee dental and hospital expenses',
        medical_expenses_due_to_incapacity: 'D02 - Medical expenses due to incapacity',
        funeral_expenses: 'D03 - Funeral expenses',
        donations: 'D04 - Donations',
        interest_paid_for_mortgage_loans: 'D05 - Interest paid for mortgage loans',
        voluntary_contributions_to_SAR: 'D06 - Voluntary contributions to SAR',
        medical_expense_insurance: 'D07 - Medical expense insurance',
        school_transportation_expenses: 'D08 - School transportation expenses',
        deposits_in_savings_accounts_based_on_pension_plans:
          'D09 - Deposits in savings accounts based on pension plans',
        payments_for_educational_services: 'D10 - Payments for educational services',
        no_tax_effects: 'S01 - No tax effects',
        payments: 'CP01 - Payments',
        paysheet: 'CN01 - Paysheet',
        to_define_cfdi: 'P01 - To define'
      }
    },
    contract: {
      acs_server: 'ACS Server',
      address_ip: 'IP address',
      address_ip_cont: 'IP Address',
      authorize_ont_in_service: 'Authorize onu in service',
      automatic_catv_control_enabled: 'Automatic CATV control ',
      automatic_catv_control_enabled_eq: 'CATV Control ',
      automatic_catv_control_enabled_eq_both: 'Both',
      automatic_catv_control_enabled_eq_disabled: 'Disabled',
      automatic_catv_control_enabled_eq_enabled: 'Enabled',
      board: 'Board',
      cable_modem_enabled: 'Cable modem enabled',
      cable_modem_enabled_eq: 'Cable Modem',
      cable_modem_enabled_eq_both: 'Both',
      cable_modem_enabled_eq_disabled: 'Disabled',
      cable_modem_enabled_eq_enabled: 'Enabled',
      cable_modem_file: 'Cable modem custom DOCSIS binary file',
      cable_modem_gateway: 'Cable modem gateway',
      cable_modem_ip: 'Cable modem ip',
      cable_modem_mac_address: 'Cable modem mac address',
      cable_modem_mac_address_cont: 'Cable modem mac address',
      ceil_dfl_percent: 'Ceil DFL percentage',
      ceil_dfl_percent_eq: 'Ceil DFL percentage',
      client: 'Client',
      client_city_eq: 'City',
      client_collector_id_eq: 'Collector',
      client_custom_id_eq: 'Customizable identifier',
      client_invoicing_client_automatic_state_eq: 'Automatic state',
      client_invoicing_client_automatic_state_eq_both: 'Both',
      client_invoicing_client_automatic_state_eq_disabled: 'Disabled',
      client_invoicing_client_automatic_state_eq_enabled: 'Enabled',
      client_invoicing_client_invoicing_enabled_eq: 'Invoicing',
      client_invoicing_client_invoicing_enabled_eq_both: 'Both',
      client_invoicing_client_invoicing_enabled_eq_disabled: 'Disabled',
      client_invoicing_client_invoicing_enabled_eq_enabled: 'Enabled',
      client_invoicing_client_invoicing_firm_id_eq: 'Invoicing Firm',
      client_invoicing_client_taxpayer_identification_number_cont: 'Taxpayer identification number',
      client_name_unaccent_cont: 'Name',
      client_national_identification_number_cont: 'National identifier number',
      client_neighborhood_id_eq: 'Neighborhood',
      client_seller_id_eq: 'Seller',
      client_sequential_id_eq: 'Client ID',
      client_state_eq: 'State',
      client_zoneables_zone_id_eq: 'Zone',
      contract_discounts: 'Discounts',
      contract_with_error: 'Contract with error',
      contracts_with_errors: 'Contracts with errors',
      coverage: 'Coverage',
      coverage_id: 'Coverage',
      coverage_id_eq: 'Coverage',
      coverage_node_id_eq: 'Node',
      cpe_port: 'CPE Port',
      cpe_protocol: 'CPE Protocol',
      created_at: 'Created at',
      created_at_gteq: 'Created at (Init)',
      created_at_lteq: 'Created at (End)',
      custom_netmask: 'Netmask',
      date_start: 'Start Date',
      deleted_at: 'Deleted at',
      delinquent_status: 'Invoicing status',
      Destination: 'Destination',
      details: 'Observations',
      details_unaccent_cont: 'Observations',
      dhcp_enable: 'DHCP enabled',
      dhcp_enabled: 'Dhcp enabled',
      dhcp_enabled_eq: 'DHCP',
      dhcp_enabled_eq_both: 'Both',
      dhcp_enabled_eq_disabled: 'Disabled',
      dhcp_enabled_eq_enabled: 'Enabled',
      dhcp_mac_address: 'DHCP Relay MAC Address',
      dhcp_mac_address_cont: 'DHCP Relay MAC Address',
      dhcp_mac_defined_by_service: 'DHCP Relay?',
      dhcp_server: 'DHCP Server',
      discounts_to_apply_filter: 'Discounts',
      discounts_to_apply_filter_both: 'Both',
      discounts_to_apply_filter_with: 'With discounts',
      discounts_to_apply_filter_without: 'Without discounts',
      dns_one: 'First DNS',
      dns_two: 'Second DNS',
      due_from: 'Due from (Dates)',
      due_to: 'Due to (Dates)',
      extra_vlans_cont: 'Extra Vlans',
      extra_vlans_hint: "Write the Vlans without spaces and separated by commas, e.g. '101,102,103'",
      file_delimiter: 'Separator',
      file_encoding: 'Encoding',
      fill_field: 'You must fill at least one field in the form',
      format_serial_to_hex: 'Format serial number to hex format',
      forwarded_port: {
        address: 'Address',
        interface: 'Interface',
        private_port: 'Private port',
        public_port: 'Public port',
        tcp: 'tcp',
        udp: 'udp'
      },
      forwarded_ports_tooltip: 'Forwarded ports',
      frame: 'Frame',
      gateway: 'Gateway',
      general_info: 'General Info',
      gps_point_attributes: {
        additional_data: 'Additional data',
        city: 'City',
        country: 'Country',
        latitude: 'Latitude',
        longitude: 'Longitude',
        number: 'Number',
        state: 'State',
        street: 'Street'
      },
      gps_point_number_or_gps_point_street_unaccent_cont: 'Address',
      has_acs: 'ACS',
      id: 'ID',
      id_or_sequential_id_eq: 'Contract (ID)',
      interface_gpon: 'Interface GPON',
      interface_gpon_eq: 'Interface (Ex. 0/0/1 or g0/1)',
      interface_mkt_network: 'Interface Mikrotik Network',
      inventory_article_ids: 'Articles',
      inventory_articles: 'Inventory articles',
      invoicing_contract_delinquent: 'Delinquent',
      invoicing_contract_disabled_date_by_system: 'Disabled by system on',
      invoicing_contract_disabled_date_by_system_gteq: 'Disabled by system on (From)',
      invoicing_contract_disabled_date_by_system_lteq: 'Disabled by system on (To)',
      invoicing_contract_profile_id_eq: 'Profile',
      invoicing_contract_social_stratum_eq: 'Social stratum',
      invoicing_contract_start_invoicing_date_eq: 'Start invoicing date',
      invoicing_contract_up_to_date: 'Up to date (no debt)',
      invoicing_info: 'Invoicing Info',
      ip: 'IP',
      items_completed: 'invoiced items',
      items_completed_infinity: 'invoiced items (will be invoiced indefinitely)',
      items_remaining: 'items to be invoiced',
      mac_address: 'MAC Address',
      mac_address_cont: 'MAC Address',
      mac_address_for_dhcp: 'MAC address for DHCP',
      massive_update: {
        add_period: 'Add period',
        ceil_dfl_percent: 'Ceil DFL percentage',
        cpe_port: 'CPE Port',
        cpe_protocol: 'CPE Protocol',
        current_period: 'Current period',
        delete_period: 'Delete period',
        details: 'Observations',
        invoicing_contract_attributes: {
          invoicing_profile_id: 'Invoicing Profile',
          price: 'Price'
        },
        massive_update: 'Massive update',
        mikrotik_interface_id: 'Mikrotik interface',
        plan_id: 'Plan',
        ppp_profile_id: 'PPP Profile',
        server_configuration_id: 'Server',
        state: 'State',
        subtract_period: 'Subtract period'
      },
      massive_update_preview_prefix: 'Will be updated',
      massive_update_preview_subfix: 'the data to be updated is:',
      mikrotik_address_network: 'Network',
      mikrotik_interface_id: 'Mikrotik interface',
      mikrotik_priority_queue_hint:
        'To enable Mikrotik configurations, you must first select a Mikrotik Server in the Basic tab',
      mikrotik_traffic_control: 'Mikrotik Bandwidth control',
      mu: {
        frecuency: 'Invoicing frequency',
        olt_mode: 'OLT Mode',
        pppoe_server: 'PPPoE server name',
        wireless_node: 'Wireless NODE'
      },
      name: 'Name',
      nap_id: 'NAP (ID)',
      nap_id_eq: 'NAP',
      navigation_vlan: 'Vlan',
      navigation_vlan_eq: 'Vlan',
      netmask: 'Netmask',
      no_client_selected_text: 'Choose one in the Client Input',
      no_client_selected_title: 'No Client Selected',
      no_consumption_summary_data: 'No data on consumption',
      no_options_interface: 'No Lan interfaces found',
      no_permission_to_action: '<0>No ONU associated. Requires authorization:</0>No permission to perform actions',
      olt_enabled_eq: 'OLT Enabled',
      olt_enabled_eq_both: 'Both',
      olt_enabled_eq_disabled: 'Disabled',
      olt_enabled_eq_enabled: 'Enabled',
      olt_id_eq_any: 'OLTs',
      olt_traffic_control_enabled: 'OLT Bandwidth control',
      olt_traffic_control_enabled_eq: 'Bandwidth control OLT',
      olt_traffic_control_enabled_eq_both: 'Both',
      olt_traffic_control_enabled_eq_disabled: 'Disabled',
      olt_traffic_control_enabled_eq_enabled: 'Enabled',
      olt_wan_provisioning: 'WAN provisioning',
      olt_wan_provisioning_eq: 'WAN Provisioning',
      olt_wan_provisioning_eq_both: 'Both',
      olt_wan_provisioning_eq_disabled: 'Disabled',
      olt_wan_provisioning_eq_enabled: 'Enabled',
      online_eq: 'ONU State',
      online_eq_both: 'Both',
      online_eq_disabled: 'Offline',
      online_eq_enabled: 'Online',
      online_state: `Contract: (Online)`,
      online_state_both: 'Both',
      online_state_offline: 'Offline',
      online_state_online: 'Online',
      ont_custom_tr069_profile: 'TR069 Profile',
      ont_custom_tr069_profile_hint: 'Write the profile-name of the TR069 Profile to use.',
      ont_desync: 'ONU Desync',
      ont_id: 'ONU',
      ont_id_not_null: 'With linked ONUs',
      ont_id_not_null_both: 'Both',
      ont_id_not_null_false: 'Without ONUs',
      ont_id_not_null_true: 'With ONUs',
      ont_last_down_cause: 'ONU Last down cause',
      ont_mode: 'ONU mode',
      ont_number: 'ONU ID',
      ont_number_eq: 'ONU ID',
      ont_offline: 'ONU Offline',
      ont_routing_mode: 'ONU mode',
      ont_serial_number: 'ONU Serial number',
      ont_serial_number_eq: 'ONU Serial number',
      ont_signal_eq: 'ONU Signal',
      ont_signal_eq_all: 'All',
      ont_signal_eq_critical: 'Critical',
      ont_signal_eq_warning: 'Warning',
      paranoia_active: 'Active',
      paranoia_both: 'Both',
      paranoia_deleted: 'Removed',
      paranoia_filter: 'Contract status',
      parent_queue: 'Parent queue',
      plan_bmu: 'Plan',
      plan_id: 'Plan',
      plan_id_eq: 'Plan',
      port_prios: 'Priority ports',
      ppp_profile: 'PPP Profile',
      ppp_profile_form_collection: 'PPP Profile',
      ppp_profile_id: 'Ppp Profile',
      ppp_profile_id_eq: 'PPP Profile',
      ppp_profile_searcher_collection: 'PPP Profile',
      pppoe_enabled: 'PPPoE enabled',
      pppoe_enabled_eq: 'PPPoE',
      pppoe_enabled_eq_both: 'Both',
      pppoe_enabled_eq_disabled: 'Disabled',
      pppoe_enabled_eq_enabled: 'Enabled',
      pppoe_password: 'PPPoE Password',
      pppoe_username: 'PPPoE Username',
      pppoe_username_cont: 'PPPoE Username',
      prio_helpers: 'High priority netfilter helpers',
      prio_protos: 'High priority protocols',
      priority_download_queue: 'Priority download queue',
      priority_upload_queue: 'Priority upload queue',
      provisioning_mode: 'Provisioning mode',
      public_address: 'FULL-NAT Address',
      public_address_id: 'FULL-NAT Address',
      public_address_id_null: 'FULL-NAT',
      public_address_id_null_both: 'Both',
      public_address_id_null_not_present: 'Not Present',
      public_address_id_null_present: 'Present',
      public_address_ip_cont: 'FULL-NAT (IP)',
      routing_mode: 'Routing mode',
      routing_mode_eq: 'Modo',
      routing_mode_eq_both: 'Both',
      routing_mode_eq_disabled: 'Bridge',
      routing_mode_eq_enabled: 'Router',
      seal_code_matches: 'Seal name',
      searcher_tabs: {
        client: 'Client',
        contract: 'Contract',
        invoicing: 'Invoicing'
      },
      select_contract: 'Should select at least one contract',
      sequential_id: 'Contract ID',
      sequential_id_eq: 'Contract ID',
      server_configuration: 'Server',
      server_configuration_id: 'Server',
      server_configuration_id_eq_any: 'Servers',
      server_traffic_control_enabled: 'Bandwidth control Server',
      server_traffic_control_enabled_eq: 'Bandwidth control Server',
      server_traffic_control_enabled_eq_both: 'Both',
      server_traffic_control_enabled_eq_disabled: 'Disabled',
      server_traffic_control_enabled_eq_enabled: 'Enabled',
      service_dgo_eq: 'Directv Go Service',
      service_dgo_eq_both: 'Both',
      service_dgo_eq_disabled: 'Disabled',
      service_dgo_eq_enabled: 'Enabled',
      service_mikrotik_server_id: 'DHCP Server',
      service_olt_ont_offline_without_disabled_deactivated_and_navigation_control:
        'Offline ONUs (without disabled contracts with navigation control)',
      service_olt_ont_with_error_rules: 'ONUs with errors rules',
      service_olt_ont_with_pending_rules: 'ONUs with pending rules',
      service_wispro_box_acs_eq: 'ACS',
      service_wispro_box_acs_eq_both: 'Both',
      service_wispro_box_acs_eq_disabled: 'Disabled',
      service_wispro_box_acs_eq_enabled: 'Habilitado',
      service_wispro_box_eq: 'WisproBox',
      service_wispro_box_eq_both: 'Both',
      service_wispro_box_eq_disabled: 'Enabled',
      service_wispro_box_eq_enabled: 'Disabled',
      start_date: 'Start date',
      state_eq_any: `Contract: (Status)`,
      state_eq_any_alerted: 'Alerted',
      state_eq_any_degraded: 'Degraded',
      state_eq_any_disabled: 'Disabled',
      state_eq_any_enabled: 'Enabled',
      table_header_tooltip_color_disabled: 'Invoicing Disabled',
      table_header_tooltip_color_generated: 'Enabled Billing, You will be able to generate Service Invoices.',
      table_header_tooltip_color_not_generated:
        'Invoicing Enabled, Generate Initial Invoice and Cancel Initial Invoice',
      table_header_tooltip_invoicing_cancel_initial_invoice:
        '<0/>: Void the initial invoice before issuance. Irreversible action.',
      table_header_tooltip_invoicing_discount:
        'Displays the quantity of active Discount Items in the contract, you will be able to update them by editing the contract in the billing tab.',
      table_header_tooltip_invoicing_generate_initial_invoice: '<0/>: Start the invoicing cycle with an itemized form.',
      table_header_tooltip_invoicing_generate_service_invoice: '<0/>: Available after creating initial invoice.',
      table_header_tooltip_invoicing_payment_promise:
        'Indicates the number of active Payment Promises assigned to this contract. Clicking the icon will provide access to the Payment Promises menu for managing them.',
      table_header_tooltip_invoicing_recurring_item:
        'Displays the number of active recurring Items in the contract, you can update them by editing the contract in the billing tab.',
      table_header_tooltip_invoicing_view_invoicing_info: '<0/>: View details and settings of your billing profile.',
      table_header_tooltip_ont_nap_port_subtitle: 'View and copy the Nap port to wich the contract is connected.',
      table_header_tooltip_ont_nap_subtitle:
        'Hover over this icon to see the NAP previously assigned to an OLT in the contract.',
      table_header_tooltip_ont_olt_linked: '<0>Contract is linked to an ONU:</0> Possible actions: ',
      table_header_tooltip_ont_olt_not_linked: '<0>The OLT is not linked</0>',
      table_header_tooltip_ont_olt_not_pending_cfg: '<0>The contract is not linked to an ONU:</0> Possible actions:',
      table_header_tooltip_ont_ont_ont_title: 'ONU/NAP/Precinct column',
      table_header_tooltip_ont_ont_subtitle: 'Actions for ONU by status',
      table_header_tooltip_ont_ont_subtitle_2: 'State of changes in ONU',
      table_header_tooltip_ont_seal_subtitle:
        'View and copy the seal code assigned to the contract quickly and easily.',
      table_header_tooltip_ont_unsync: '<0>ONU not synchronized:</0> Possible actions:',
      table_header_tooltip_ont_w_config:
        '<0>Contract related to ONU in link mode (Related using pre-existing configuration in olt).</0> Actions NOT supported:',
      table_header_tooltip_ont_w_onlylink_hint:
        '<0>Contract related to ONU in NO link mode (Related and authorized with Wispro configuration)</0>',
      table_header_tooltip_ont_w_onlylink_qoute: 'You can link the ONU without losing your pre-existing configuration',
      table_header_tooltip_ont_with_error_rules: '<0>Errors ocurred while trying to apply changes in the ONU<0/>',
      table_header_tooltip_ont_with_pending_rules: '<0>There are changes being applied to the ONU<0/>',
      tcp_prio_ports: 'High priority TCP ports',
      to_be_disabled_between: 'Due (Dates)',
      udp_prio_ports: 'High priority UDP ports',
      wifi_password: 'Wifi password',
      with_active_recurring_items_for_kind_id: 'Recurring Item',
      with_clients_with_pending_invoices: 'Of clients with pending invoices',
      with_discounts_to_apply: 'With discount',
      with_generation_error: 'With generation error',
      with_manually_modified_price: 'Manually modified price',
      with_pending_invoices: 'With pending invoices',
      with_valid_payment_promises: 'With active payment promises',
      with_zero_balance: 'With zero balance',
      without_discounts_to_apply: 'Without discount',
      without_initial_invoice: 'Without initial invoice',
      without_invoices_current_period: 'Without invoices from period'
    },
    coverage: {
      contracts_count: 'Contracts'
    },
    dashboard: {
      download: 'Download',
      month: 'Month',
      upload: 'Upload',
      year2: 'Year'
    },
    dhcp_server: {
      name: 'Name',
      kind: 'Kind',
      user: 'User',
      password: 'Password',
      mikrotik_use_ssl: 'API-SSL',
      host: 'Host',
      port: 'Port',
      link_status: 'Link',
      contracts_count: 'Contracts',
      last_seen: 'Last seen',
      lease_time: 'Least time'
    },
    disk: {
      prepare_disk_for: 'Assign to',
      prepare_disk_for_cache: 'Prepare disk for cache',
      serial: 'Serial number'
    },
    employee: {
      public_key: 'Public RSA',
      user_email: 'User email',
      user_password: 'Password',
      user_password_confirmation: 'Password confirmation',
      user_public_key: 'Public Key',
      user: {
        password_confirmation: 'Password confirmation',
        public_key: 'Public Key',
        role_ids: [
          'Roles',
          {
            admin: 'Admin',
            administrative: 'Administrative',
            administrative_read_only: 'Read only Administrative',
            administrative_supervisor: 'Administrative supervisor',
            administrative_supervisor_read_only: 'Read only Administrative supervisor',
            collector: 'Collector',
            collector_read_only: 'Read only Collector',
            external_technician: 'External Technician',
            general_manager: 'General manager',
            general_manager_read_only: 'Read only General manager',
            helpdesk: 'Helpdesk',
            helpdesk_read_only: 'Read only Helpdesk',
            helpdesk_supervisor: 'Helpdesk supervisor',
            helpdesk_supervisor_read_only: 'Read only Helpdesk supervisor',
            installer: 'Installer',
            installer_read_only: 'Read only Installer',
            installer_supervisor: 'Installer supervisor',
            installer_supervisor_read_only: 'Read only Installer supervisor',
            owner: 'Owner',
            sale_desk: 'Sale desk',
            sale_desk_read_only: 'Read only Sale desk',
            sale_desk_supervisor: 'Sale desk supervisor',
            sale_desk_supervisor_read_only: 'Read only Sale desk supervisor',
            seller_read_only: 'Read only Seller',
            seller: 'Seller',
            support: 'Support',
            technician: 'Technician',
            technician_read_only: 'Read only Technician',
            technician_supervisor: 'Technician supervisor',
            technician_supervisor_read_only: 'Read only Technician supervisor'
          }
        ]
      },
      user_zones: 'Zones',
      zones: 'Zones'
    },
    feedback: {
      kind: 'Kind Feedback',
      kind_feedback: 'Kind Feedback'
    },
    freeradius_client: {
      secret: 'Secret'
    },
    frecuency: {
      ['1']: 'Monthly',
      ['2']: 'Bimonthly',
      ['3']: 'Every three months',
      ['4']: 'Quarterly',
      ['6']: 'Semiannual ',
      ['12']: 'Annual'
    },
    gps_point: {
      additional_data: 'Additional data',
      latitude: 'Latitude',
      longitude: 'Longitude'
    },
    helpdesk: {
      issue: {
        all_issues: 'All issues',
        assignable: 'Assigned to',
        assignable_id: 'Assigned to',
        assignable_type: 'Type',
        assigned_at: 'Assigned at',
        assigned_to: 'Assigned to',
        states: {
          pending: 'Pending',
          assigned: 'Assigned',
          finalized: 'Finalized',
          closed: 'Closed',
          reopened: 'Reopened'
        },
        client_custom_id_eq: 'Customizable identifier',
        client_national_identification_number_cont: 'National identifier number',
        client_state_eq: 'State',
        complexity_eq_any_high: 'High',
        complexity_eq_any_medium: 'Medium',
        complexity_eq_any_low: 'Low',
        complexity_eq_any: 'Complexity',
        contract_cable_modem_enabled_true: 'Enabled',
        contract_cable_modem_enabled_false: 'Disabled',
        contract_cable_modem_enabled_both: 'Both',
        contract_dhcp_enabled_true: 'Enabled',
        contract_dhcp_enabled_false: 'Disabled',
        contract_dhcp_enabled_both: 'Both',
        contract_public_address_id_null_present: 'Present',
        contract_public_address_id_null_not_present: 'Not Present',
        contract_public_address_id_null_both: 'Both',
        contract_pppoe_enabled_true: 'Enabled',
        contract_pppoe_enabled_false: 'Disabled',
        contract_pppoe_enabled_both: 'Both',
        contract_sequential_id: 'Contract ID',
        created_at_gteq: 'Created At (from)',
        created_at_lteq: 'Created At (to)',
        expires_at: 'Due At',
        expires_at_gteq: 'Due At (from)',
        expires_at_lteq: 'Due At (to)',
        help_desk_issue_category_id: 'Category',
        issue_category: 'Category',
        main_category: 'Main category',
        main_help_desk_issue_category_id: 'Main category',
        mobile_true: 'App Mobile',
        mobile_false: 'Manual',
        mobile_both: 'Both',
        mobile_eq: 'App Mobile',
        only_my_issues: 'Only my issues',
        priority_eq_any_low: 'Low',
        priority_eq_any_medium: 'Medium',
        priority_eq_any_high: 'High',
        priority_eq_any: 'Priority',
        secondary_category: 'Secondary category',
        sequential_id: 'Issue number',
        state_pending: 'Pending',
        state_assigned: 'Assigned',
        state_finalized: 'Finalized',
        state_closed: 'Closed',
        state_reopened: 'Reopened',
        to_be_invoiced: 'To be invoiced',
        to_be_invoiced_true: 'To be invoiced',
        to_be_invoiced_false: 'Not be invoiced',
        to_be_invoiced_both: 'Both',
        to_be_invoiced_eq: 'To be invoiced',
        uniq_code_numeric: {
          add_cun: 'Add CUN',
          assign_cun: 'Assign CUN',
          base_code: 'Base code',
          create_format_cun: 'Create new CUN format',
          cun: 'CUN',
          custom_no_record_title: 'There are no CUN formats to show',
          default_type: 'Format type',
          edit_format_cun: 'Edit CUN format',
          format_cun: 'Format CUN number',
          length_code: 'Length code',
          prefix: 'Prefix',
          separator: 'Separator',
          sequential_code: 'Sequential code',
          sufix: 'Sufix',
          tickets_with_cun: 'Tickets with CUN',
          type_code: 'Type code'
        },
        viewed_true: 'Viewed',
        viewed_false: 'Unviewed',
        viewed_both: 'Both',
        viewed_eq: 'Viewed'
      },
      issue_category: {
        help_desk_issues: 'Issues'
      }
    },
    hola_notification: {
      automatics: 'Automatics',
      automatic_notifications: {
        activate_automatic_notification_tooltip: 'To activate automatic notifications you must configure a Template',
        banner: {
          title: 'From this section you can',
          config_hint: 'Configure how notifications are sent to your customers, select template and go.',
          power_hint: 'Enable or disable automatic sending according to your needs.'
        },
        channels: {
          activate_automatic_notification: 'To activate automatic notifications you must configure a Channel'
        },
        kind: {
          client_created: 'Send messages when a client is created',
          contract_disabled: 'Send messages when a contract is disabled',
          dgo_subscription_created: 'Send messages when a DGO subscription is created',
          issued_invoice: 'Send messages when the invoice is issued',
          order_finalized: 'I’ll confirm this one later',
          order_scheduled: 'Send messages when a visit is scheduled',
          payment_created: 'Send messages when a payment is created'
        },
        template: {
          activate_automatic_notification: 'To activate automatic notifications you must configure a Template',
          no_results: 'There are no Templates to display',
          no_templates_available: 'No Templates available',
          search_template: 'Search Template...'
        },
        you_must_activate_the_service_to_continue_with_the_setup:
          'You must activate the service to continue with the setup'
      },
      client_notifications: {
        kind: {
          client_created: 'Welcome',
          contract_disabled: 'Contract disabled',
          dgo_subscription_created: 'DGO subscription created',
          issued_invoice: 'Issued invoice',
          payment_created: 'Payment created',
          invoice_issued: 'Invoice'
        },
        status: {
          sent: 'Sent'
        }
      },
      template_configurations: {
        form: {
          template_hola: 'Template',
          channel: 'Channel',
          title: {
            create_template_configuration: 'Create Template',
            edit_template_configuration: 'Edit Template'
          }
        },
        create_templates: 'Create templates?',
        there_are_no_templates: 'There are no Templates to display'
      },
      manual_notifications: {}
    },
    installation_order: {
      assigned_date: 'Assigned Date',
      coverage_id: 'Coverage',
      gps_point_id: 'Gps Point',
      installation_date: 'Installation date',
      nap_id: 'NAP (ID)',
      order_state_id: 'Order state (ID)'
    },
    installation_order_configuration: {
      email: 'Contact email',
      phone: 'Contact phone'
    },
    installation_order_event: {
      end_at: 'Ends at',
      start_at: 'Scheduled at'
    },
    interface: {
      addresses: 'Addresses',
      auto_detected_as: 'Auto detect (Interface)',
      included_in: 'Include in',
      kind: 'Kind',
      link: 'Link',
      name: 'Name'
    },
    inventory: {
      auto_detected_as: 'Auto detect (Interface)',
      article: { product_code: 'Product Code' },
      dealer: {
        product_catalog: 'Product catalog'
      },
      movement: {
        destiny: 'Destiny'
      },
      stock: {
        maxstock: 'Maximum Stock',
        minstock: 'Minimum Stock'
      }
    },
    invoicing: {
      abstract_invoice: {
        base_invoiced_date: 'Period start date',
        client_address: 'Address (client)',
        client_national_identification_number: 'Client national identification number',
        client_payment_way: 'Payment Way',
        client_taxpayer_identification_number: 'Client taxpayer identification number',
        client_vat_condition: 'Vat condition client',
        firm_address: 'Address (invoicing firm)',
        firm_company_name: 'Company name (invoicing firm)',
        firm_email: 'Email (invoicing firm)',
        firm_gross_income: 'Gross income (invoicing firm)',
        firm_phone: 'Phone (invoicing firm)',
        firm_principal_activity: 'Principal activity (invoicing firm)',
        firm_sale_point: 'Point of sale (invoicing firm)',
        firm_start_activities_date: 'Start date of activities(invoicing firm)',
        firm_taxpayer_identification_number: 'Tax identification number (invoicing firm)',
        firm_vat_condition: 'VAT condition (invoicing firm)',
        firm_zip: 'Zip (invoicing firm)',
        firm_zip_code: 'Zip code (invoicing firm)',
        first_due_date: 'First due date',
        id: 'Amount ID',
        interest_second_due_date: 'Interest second due date',
        invoicing_abstract_invoice_id: 'Invoice (ID)',
        invoicing_concept: 'Invoice Concept',
        invoicing_invoicing_firm_id: 'Invoicing firm (ID)',
        issue_state: 'Issue state',
        issue_states: {
          issuing: 'Issuing',
          issued: 'Issued',
          not_issued: 'Not Issued'
        },
        limit_invoiced_date: 'Limit invoiced date',
        second_due_date: 'Second due date',
        surcharge_for_first_due_date: 'Surcharge first due',
        surcharge_for_second_due_date: 'Surcharge second due'
      },
      cash_audit: {
        cash_audit_id: 'ID Cash Audit',
        creatable_id: 'Created by',
        creatable_type: 'Type',
        created_by: 'Created by',
        transactions: 'Transactions'
      },
      client: {
        additional_one: 'Additional info',
        additional_two: 'Additional info 2',
        balance_amount: 'Balance amount',
        client_gateway_alias: 'Alias',
        client_gateway_cbu: 'CBU',
        argentina: {
          client_gateway_id: 'Client number',
          cobro_digital_pago_mis_cuentas: 'PagoMisCuentas Code',
          digital_barcode: 'Client barcode',
          taxpayer_identification_number: 'CUIT/CUIL',
          vat_condition: 'Vat condition'
        },
        authorize_invoice_after_paid: 'Inform after paid',
        automatic_state: 'Automatic state',
        client_id: 'ID Client',
        colombia: {
          sale_point_town: 'Municipality',
          tax_responsibility: 'Tax Responsibility',
          taxpayer_identification_number: 'CC/CE/NIT',
          vat_condition: 'Regime'
        },
        concept: 'CFDI use',
        costa_rica: {
          taxpayer_identification_number: 'Taxpayer identification number',
          vat_condition: 'Vat condition'
        },
        device_token: 'Device token',
        ecuador: {
          taxpayer_identification_number: 'Identification number / RUC',
          vat_condition: 'Regime'
        },
        emails_to_notify: 'Emails to notify',
        generic: {
          client_gateway_id: 'Gateway Client number',
          taxpayer_identification_number: 'Taxpayer identification number'
        },
        invoicing_enabled: 'Invoicing',
        invoicing_enabled_title_for_check: 'Enable Invoicing',
        invoicing_firm: 'Invoicing firm',
        mexico: {
          taxpayer_identification_number: 'RFC',
          vat_condition: 'Regime',
          invoicing_name: 'Invoicing name'
        },
        next_period: 'Do not invoice the current period, invoice from the next period',
        panama: {
          taxpayer_identification_number: 'NIT',
          vat_condition: 'Regime'
        },
        peru: {
          vat_condition: 'Kind of person to invoice',
          taxpayer_identification_number: 'RUC',
          invoicing_name: 'Name/Invoicing firm'
        },
        partial_period: 'Invoice partial days, from day',
        payment_way: 'Payment way',
        send_email_when_create_payment: 'Send email when create payment',
        send_email_when_issue_invoices: 'Send email when issue invoice',
        start_invoicing_day: 'Billing cycle starts on the day',
        tax_one: 'Tax',
        tax_one_id: 'Tax',
        taxpayer_identification_number: 'Taxpayer identification number',
        total_period: 'Invoice full period'
      },
      clients_payment_gateway: {
        client_gateway_id: 'Client number',
        cobro_digital_pago_mis_cuentas: 'Code PagoMisCuentas',
        current_number_in_gateway: 'Current number in gateway',
        deleted_at: 'Deleted at',
        digital_barcode: 'Client barcode',
        invoicing_payment_gateway: 'Payment gateway',
        invoicing_payment_gateway_id: 'Payment gateway',
        link_payments: 'LinkPayments code',
        payment_gateway: 'Payment gateway',
        total_period: 'Invoice full period',
        without_payment_gateway_filter: 'Without payment gateway'
      },
      concept: {
        mexico: {
          commodity: 'G01 - Acquisition of merchandise',
          returns_discounts_bonuses: 'G02 - Returns, discounts or bonuses',
          general_expenses: 'G03 - General expenses',
          buildings: 'I01 - Buildings',
          furniture_and_office_equipment_for_investments: 'I02 - Furniture and office equipment for investments',
          transportation_equipment: 'I03 - Transportation equipment',
          computer_equipment_and_accessories: 'I04 - Computer equipment and accessories',
          craps_dies_molds_matrixes_and_tooling: 'I05 - Craps dies molds matrixes and tooling',
          telephone_communications: 'I06 - Telephone communications',
          satellite_communications: 'I07 - Satellite communications',
          other_machinery_and_equipment: 'I08 - Other machinery and equipment',
          medical_fee_dental_and_hospital_expenses: 'D01 - Medical fee dental and hospital expenses',
          medical_expenses_due_to_incapacity: 'D02 - Medical expenses due to incapacity',
          funeral_expenses: 'D03 - Funeral expenses',
          donations: 'D04 - Donations',
          interest_paid_for_mortgage_loans: 'D05 - Interest paid for mortgage loans',
          voluntary_contributions_to_SAR: 'D06 - Voluntary contributions to SAR',
          medical_expense_insurance: 'D07 - Medical expense insurance',
          school_transportation_expenses: 'D08 - School transportation expenses',
          deposits_in_savings_accounts_based_on_pension_plans:
            'D09 - Deposits in savings accounts based on pension plans',
          payments_for_educational_services: 'D10 - Payments for educational services',
          no_tax_effects: 'S01 - No tax effects',
          payments: 'CP01 - Payments',
          paysheet: 'CN01 - Paysheet',
          to_define_cfdi: 'P01 - To define'
        }
      },
      contract: {
        alerted_date_by_system: 'Alerted automatically at',
        auto_invoice_issuing: 'Auto invoice issuing',
        automatic_state: 'Automatic state',
        available_promises: 'Available promises',
        base_invoiced_date: 'Base invoiced date',
        charge_in_advance: 'Charge in advance',
        corporate_name: 'corporate name',
        current_period_invoiced: 'Current period invoiced',
        days_for_first_due: 'Days to 1º due date',
        days_for_second_due: 'Days to 2º due date',
        days_to_alert_contract: 'Days to alert contract',
        days_to_disable_contract: 'Days to disable contract',
        disabled_date_by_system: 'Disable automatically at',
        due_one_interest: 'Interest for 1º due date',
        due_two_interest: 'Interest for 2º due date',
        electronic_enabled: 'Electronic',
        generate_reconnection_charge: 'Generate reconnection charge',
        initial_invoice_generated: 'Initial invoice generated',
        invoice_day: 'Invoice day',
        invoice_generation_error: 'Invoice generation error',
        invoicing_plan_id: 'Plan',
        invoicing_profile_id: 'Invoicing profile',
        limit_invoiced_date: 'Limit invoiced date',
        next_period: 'Do not invoice the current period, invoice from the next period',
        next_period_to_invoice: 'Next period to invoice',
        not_invoice_when_is_disabled: 'Not invoice when is disabled',
        partial_period: 'Invoice partial days, from day',
        profile: 'Invoicing Profile',
        reconnection_surcharge: 'Reconnection surcharge',
        reconnection_surcharged_at: 'Reconnection surcharged at',
        second_due_date_at_end_of_period: '2º due date at end of period',
        start_invoicing_date: 'Start invoicing date',
        strategy_to_alert_contract: 'Change state to alerted',
        strategy_to_disable_contract: 'Change state to disabled',
        tax_one: 'Tax',
        tax_one_id: 'Tax',
        taxpayer_identification_number: 'Taxpayer identification number',
        total_period: 'Invoice full period',
        use_information_contract_for_invoice: 'Use information contract for invoice'
      },
      contract_discount: {
        activation_date: 'Activation date',
        amount: 'Amount',
        contract_discount_edition_enabled: 'Enable period editing when assigning discount',
        count_applied_lapse: 'Applied periods',
        discount: 'Discount',
        discountable_type: 'Applies to',
        discountable_id: 'Associated ID',
        invoicing_discount_id: 'Discount',
        lapse: 'Periods',
        state: 'State',
        strategy: 'Strategy',
        states: {
          pending: 'Pending',
          applying: 'Applying',
          applied: 'Applied',
          canceled: 'Canceled'
        }
      },
      credit_note: {
        category_placeholder: 'Select categories',
        amount: 'Amount',
        amount_available: 'Amount available',
        amount_voided: 'Cancelled amount',
        amount_to_void: 'Amount to cancel',
        credit_note_created_successfuly: 'The credit note was created',
        credit_note_created_error: 'Error creating the credit note',
        total_to_avoid_min_validation: 'The amount cannot be negative',
        total_to_avoid_max_validation: 'Cannot exceed the available amount {{ amount }}',
        cant_edit_default_category: 'You cannot edit the default category.',
        category_by_default: 'Category by default',
        total_credit_notes_column: 'Assigned credit notes'
      },
      credit_note_pool_number: {
        current: 'Using',
        expire_at: 'Expiration date'
      },
      current_account: {
        balance_amount: 'Balance',
        balance: 'C/A Balance',
        credit_amount: 'Credit',
        credit: 'Credit',
        invoice_balance_amount: 'Invoice balance',
        invoice_balance: 'Pending invoices',
        lock_version: 'Lock version'
      },
      discount: {
        amount: 'Amount',
        contract_discount_edition_enabled: 'Enable period editing when assigning discount',
        description: 'Description',
        expires_at: 'Expires at',
        fixed_amount: 'Fixed amount',
        kind: 'Kind',
        lapse: 'Lapse',
        name: 'Name',
        percentage: 'Percentage',
        starts_at: 'Starts at',
        strategy: 'Strategy',
        validity_mode: 'Validity',
        kinds: {
          other: 'Other',
          loyalty: 'Loyalty',
          new_client: 'New client',
          retention: 'Retention'
        },
        states: {
          expired: 'Expired',
          enabled: 'Enabled',
          disabled: 'Disabled'
        },
        validities: {
          with_validity: 'With validity',
          without_validity: 'Without validity'
        }
      },
      ecuador_einvoice: {
        access_code: 'Access code',
        auth_code: 'Authorization Code'
      },
      einvoice: {
        argentina: {
          cae: 'CAE',
          cae_due_date: 'CAE due date'
        },
        bill_number: 'Invoice number',
        billed_date: 'Generated at',
        vat_total: 'Total IVA'
      },
      invoice: {
        argentina: {
          client_national_identification_number: 'DNI (Client)',
          client_taxpayer_identification_number: 'CUIT/CUIL',
          client_vat_condition: 'Vat condition client',
          cobro_digital_bar_code_amount: 'Bar code (cobro digital)',
          cobro_digital_invoice_generated: 'Boleta generada cobro digital',
          cobro_digital_ticket_number: 'Ticket number (cobro digital)',
          firm_taxpayer_identification_number: 'CUIT/CUIL (invoicing firm)',
          firm_vat_condition: 'Vat condition (invoicing firm)'
        },
        authorization_state: 'Authorization state',
        authorize_invoice_after_paid: 'Inform after paid',
        base_invoiced_date: 'Init period',
        client_address: 'Address',
        client_payment_method: 'Payment method',
        client_payment_way: 'Payment way',
        clients_payment_gateways: 'Pasarelas de pago del Cliente',
        corporate_name: 'Corporate name',
        count_pre_print: 'Pre-impress count',
        credit_note_number: 'Credit note number',
        due_amount: 'Due amount',
        electronic_enabled: 'Electronic enabled',
        firm_address: 'Address (invoicing firm)',
        firm_company_name: 'Company name (invoicing firm)',
        firm_country: 'Country (invoicing firm)',
        firm_email: 'Email (invoicing firm)',
        firm_gross_income: 'Gross income (invoicing firm)',
        firm_locality: 'Locality (invoicing firm)',
        firm_phone: 'Phone (invoicing firm)',
        firm_principal_activity: 'Principal activity (invoicing firm)',
        firm_sale_point: 'Sale point (invoicing firm)',
        firm_start_activities_date: 'Start activities (invoicing firm)',
        firm_zip_code: 'Zip code (invoicing firm)',
        first_due_date: '1º due date',
        interest_first_due_date: 'interest 1st due date (Amount)',
        interest_second_due_date: 'interest 2nd due date (Amount)',
        invoice_number: 'Invoice numb.',
        invoicing_firm: 'Invoicing firm',
        invoicing_invoicing_firm: 'Invoicing firm',
        invoicing_invoicing_firm_id: 'Invoicing firm',
        issued: 'Issued',
        issuing_feedback: 'Issuing feedback',
        kind_invoice: {
          argentina_a: 'Argentine (A)',
          argentina_b: 'Argentine (B)',
          argentina_c: 'Argentine (C)',
          colombia: 'Sales invoice',
          credit_note: 'Credit note',
          ecuador: 'Sales invoice',
          espana: 'Spain',
          invoice: 'Invoice',
          mexico: 'Sales invoice',
          voucher: 'Voucher',
          peru_invoice: 'Sales invoice',
          peru_final_consumer_invoice: 'Sales final consumer invoice'
        },
        limit_invoiced_date: 'End period',
        not_service: 'Extraordinary',
        reconnection_charge: 'reconnection charge (Amount)',
        second_due_date: '2º due date',
        state: {
          draft: 'Draft',
          paid: 'Paid',
          pending: 'Pending payment',
          pending_with_first_due_date: 'Pending payment with 1º due date reached',
          pending_with_second_due_date: 'Pending payment with 2º due date reached',
          void: 'Void'
        },
        surcharge_for_first_due_date: 'Surcharge first due',
        surcharge_for_second_due_date: 'Surcharge second due',
        tax_reconnection_charge: 'Tax reconnection charge'
      },
      invoice_item: {
        invoicing_abstract_invoice_id: 'Invoice (ID)',
        kind: 'Item template',
        unit_of_measure: 'Unit of measure'
      },
      invoice_item_kind: {
        lapse: 'Period',
        mount: 'Amount',
        propagate_changes: 'Propagate changes',
        recurring: 'Recurring'
      },
      invoice_pool_number: {
        current: 'Using',
        expire_at: 'Expiration date',
        resolution_date: 'Resolution date',
        resolution_number: 'Resolution'
      },
      invoices_payment_gateway: {
        barcode: 'Barcode',
        clients_payment_gateway_id: 'Payment gateway',
        invoicing_invoice_id: 'Invoice',
        issue_feedback: 'Errors',
        preference_expire_at: 'Expire at',
        preference_url: 'Payment Url',
        raw_transaction: 'Complete transaction',
        ticket_number: 'Ticket'
      },
      invoicing_configuration: {
        company_logo: 'Logo',
        company_logo_content_type: 'Image type (Logo)',
        company_logo_file_name: 'File name (Logo)',
        company_logo_file_size: 'File size (Logo)',
        company_logo_updated_at: 'Logo updated at',
        custom_legend_for_invoice: 'Custom legend for invoice',
        custom_legend_for_invoice_hint: 'Legend to show at the invoices foot',
        custom_payment_legend: 'Legend to detail forms of payment and points of service',
        debt_in_invoice: "Include client's debt in the invoice",
        inform_total_service_debt_to_payment_gateways: 'Inform total service debt to payment gateways',
        inform_total_service_debt_to_payment_gateways_hint:
          'The service invoice will be informed to the payment gateways with the balance of the sum of all contract pending invoices.',
        invoice_numbers_payment_receipts_enabled: 'Display invoice numbers on payment receipts',
        payments_in_invoice: 'Include last payments in the invoice',
        pos_receipt_width: 'Paper width (mm)',
        pos_receipt_width_hint:
          'Setting the width of the PoS printer paper: Before using the printer you can configure the width of the paper.'
      },
      invoicing_firm: {
        argentina: {
          taxpayer_identification_number: 'CUIT/CUIL'
        },
        certificate: 'Certificado AFIP',
        certificate_expiration: 'Certificate expiration',
        colombia: {
          service_password: 'Password Token',
          service_url: 'Endpoint (FactoryHKA)',
          service_user: 'Business Token',
          taxpayer_identification_number: 'CC/CE/NIT',
          use_pdfs_from_service: 'Send FactoryHKA PDF',
          vat_condition: 'Regime'
        },
        company_name: 'Company name',
        costa_rica: {
          taxpayer_identification_number: 'Taxpayer identification number'
        },
        cumulative_amount: 'Cumulative amount',
        current_credit_note_number_argentina_a: 'Last credit note num. Argentina A',
        current_credit_note_number_argentina_b: 'Last credit note num. Argentina B',
        current_credit_note_number_argentina_c: 'Last credit note num. Argentina C',
        current_credit_note_number_colombia: 'Last credit note num. nota Colombia',
        current_credit_note_number_ecuador: 'Last credit note num. nota Ecuador',
        current_credit_note_number_espana: 'Last credit note num. España',
        current_credit_note_number_mexico: 'Last credit note num.  Mexico',
        current_credit_note_number_voucher: 'Last credit note num. nota Voucher',
        current_invoice_number_argentina_a: 'Lastinvoice num. Argentina A',
        current_invoice_number_argentina_b: 'Last invoice num. Argentina B',
        current_invoice_number_argentina_c: 'Last invoice num. Argentina C',
        current_invoice_number_ecuador: 'Last invoice num. Ecuador',
        current_invoice_number_espana: 'Last invoice num. eEpaña',
        current_invoice_number_mexico: 'Last invoice num. Mexico',
        current_invoice_number_voucher: 'Last invoice num. Voucher',
        ecuador: {
          accounting: 'Accounting Required',
          principal_activity: 'Commercial name',
          pyme: 'Microenterprise Regime',
          retention_agent_number: 'Retention agent resolution number',
          rimpe: 'RIMPE Regime',
          sale_point: 'Sale point',
          sale_point_address: 'Establishment address',
          sale_point_code: 'Establishment code',
          taxpayer_identification_number: 'RUC',
          vat_condition: 'Condition'
        },
        electronic_enabled: 'Electronic invoice',
        electronic_validated: 'Electronic account validated',
        generic: {
          taxpayer_identification_number: 'Taxpayer identification number'
        },
        gross_income: 'Gross income',
        limit_amount: 'Limit amount',
        locality: 'Locality',
        mexico: {
          fm_certificate_number: 'Num. certificate (fm)',
          fm_logo: 'Logo ID (fm)',
          fm_tax_regime: 'tax regime (fm)',
          fm_wsdl: 'Wsdl (fm)',
          sale_point: 'Serie',
          service_password: 'user pass (fm)',
          service_url: 'Endpoint (fm)',
          service_user: 'user id (fm)',
          taxpayer_identification_number: 'RFC',
          use_pdfs_from_service: 'Use FacturacionModerna PDFs',
          vat_condition: 'Regime'
        },
        principal_activity: 'Principal activity',
        sale_point_address: 'Sale point address',
        sale_point_country: 'sale point country',
        sale_point_postcode: 'sale point zip code',
        sale_point_state: 'Sale point state',
        sale_point_town: 'Sale point town',
        start_activities_date: 'Start activities date',
        webservice_feedback: 'Feedback webservice',
        zip_code: 'Zip code'
      },
      invoicing_service_invoice: {
        from_day: 'From',
        to_day: 'To',
        amount: 'Total amount',
        installation_amount: 'Installation amount',
        charge_installation: 'Charge installation?',
        auto_invoice_issuing: 'Auto invoice issuing'
      },
      isp: {
        company_logo: 'Company logo',
        company_logo_file_name: 'Company logo file name',
        company_logo_file_size: 'Company logo file size',
        company_logo_updated_at: 'Company logo updated at',
        company_logo_content_type: 'Company logo content type',
        custom_legend_for_invoice: 'Custom legend for invoice',
        custom_payment_legend: 'Legend to detail forms of payment and points of service',
        debt_in_invoice: "Include client's debt in the invoice",
        exchange_currency: 'Currency of exchange',
        first_maturity: 'First due notification',
        inform_total_service_debt_to_payment_gateways: 'Inform total service debt to payment gateways',
        invoice_numbers_payment_receipts_enabled: 'Display invoice numbers on payment receipts',
        invoicing_currency: 'Currency',
        invoicing_currency_to_exchange_currency_rate: 'Exchange rate',
        payments_in_invoice: 'Include last payments in the invoice',
        pos_receipt_width: 'Paper width (mm)',
        prisma_current_file_number: 'Prisma current file number',
        prisma_n_establecimiento_master: 'Prisma establishment number Mastercard',
        prisma_n_establecimiento_visa_credit: 'Prisma establishment number VISA credit',
        prisma_n_establecimiento_visa_debit: 'Prisma establishment number VISA debit',
        run_daemon_invoicing_at: 'Run daemon invoicing at',
        second_maturity: 'Second due notification',
        use_net_amount: 'use net amount'
      },
      item_tax: {
        code: 'Code',
        invoicing_tax_id: 'ID',
        rate: 'Rate',
        taxable_id: 'ID',
        taxable_type: 'Type'
      },
      payment: {
        amount_entered: 'Amount',
        change: 'Change',
        collected_by: 'Collected by',
        collector_email: 'Collector Email',
        created_at: 'Registered at',
        created_at_gteq: 'Registered At (from)',
        created_at_lteq: 'Registered At (to)',
        credit_amount: 'Credit',
        email_collector: 'Collector Email',
        email_user: 'User Email',
        invoices: 'Pending invoices',
        lock_version: 'Lock version',
        name_collector: 'Collector name',
        name_user: 'Registered by',
        pay_with_credit_current_account: 'Pay with current account credit',
        payment_date: 'Payment date',
        payment_date_gteq: 'Payment date (from)',
        payment_date_lteq: 'Payment date (to)',
        payment_transactions_filter_with: 'With associated invoices',
        payment_transactions_filter_without: 'Without associated invoices',
        payment_transactions_filter_both: 'Both',
        payment_transactions_filter: 'Associated invoices',
        pos_print_after_create: 'Print (PoS) after the payment creation',
        print_after_create: 'Print after the payment creation',
        registered_by: 'Registered by',
        save_in_current_account: 'Save change in current account',
        sequential_id: 'Payment ID',
        total_owed: 'Total owed',
        transaction_code: 'Unique transaction code',
        transaction_kind: 'Transaction',
        transaction_kind_id: 'Transaction (ID)'
      },
      payment_gateway: {
        integration_api_key: 'Integration API key',
        seed_code: 'Seed code',
        account_id: 'Account ID',
        api_key: 'Api Key',
        api_login: 'Api Login',
        auto_confirm: 'Confirm automatically',
        automatic_debit: 'Automatic debit',
        bancolombia: {
          agreement_number: 'Número de convenio',
          nit: 'NIT'
        },
        cardnet: {
          account_id: 'Mcc',
          merchant_id: 'Cardnet Name'
        },
        cobro_digital: {
          cobro_digital_address_key: 'Address',
          cobro_digital_email_key: 'Email',
          cobro_digital_full_name_key: 'Fullname',
          cobro_digital_identifier_key: 'Client identifier',
          cobro_digital_national_identifier_key: 'National identifier number',
          emit_hint_off:
            ' <0>OFF Mode:</0> They will report to CobroDigital with the 1st and 2nd due date of each invoice (as set in the profile), and a 3rd report at the end of the period (internet service) or end of month (manual invoices).',
          emit_hint_on:
            ' <0>ON Mode:</0> It will report to CobroDigital the same as "Mode OFF" with an additional due date 5 days after the issue date (useful for automatic debit from PagoMisCuentas, Link or others and quick collection).'
        },
        cobro_digital_address_key: 'Address',
        cobro_digital_email_key: 'Email',
        cobro_digital_full_name_key: 'Full name',
        cobro_digital_identifier_key: 'Client ID',
        cobro_digital_national_identifier_key: 'National identifier',
        consuerte: {
          box_hint_title: 'Steps to use Consuerte:',
          box_hint1: 'Contract the Consuerte service. ',
          box_hint2: 'Request integration with Wispro.',
          box_hint3: 'Give the Consuerte team the API Key (Token) Assigned by Wispro.',
          form_hint:
            'Once you create your payment gateway with Consuerte the API KEY information will be provided in the details section.'
        },
        efecty: {
          box_hint_title: 'Steps to use Efecty:',
          box_hint1: 'Contract the Efecty service. ',
          box_hint2: 'Request integration with Wispro.',
          box_hint3: 'Give the Efecty team the API Key (Token) Assigned by Wispro.',
          form_hint:
            'Once you create your payment gateway with Efecty the API KEY information will be provided in the details section.'
        },
        enabled: 'State',
        fast_recolection: 'Issue invoice strategy (CobroDigital)',
        gateway_name: 'Gateway',
        inform_emit_disabled: 'Report invoice emission disabled',
        inform_emit_enabled: 'Report invoice emission enabled',
        ipg_issue_enabled: 'Report invoices to the payment gateway',
        merchant_id: 'Merchant ID',
        mi_vecino: 'Mi Vecino',
        must_provide_info_to_facilito: "Must provide the following information to Facilito's team",
        must_provide_info_to_pichincha: 'Must provide the following information to Pichincha team',
        payu: {
          account_id: 'Account ID',
          merchant_id: 'Merchant ID'
        },
        pending_varification: 'Pending verification by Wispro',
        pichincha_bank_debit: 'Pichincha bank (Automatic debit)',
        prisma_visa_credit: {
          account_id: 'Prisma establishment number VISA credit',
          current_file_number: 'Prisma current file number'
        },
        prisma_visa_debit: {
          account_id: 'Prisma establishment number VISA debit',
          current_file_number: 'Prisma current file number'
        },
        prisma_master: {
          account_id: 'Prisma establishment number Mastercard',
          current_file_number: 'Prisma current file number'
        },
        propagate_ipg_issue_enabled: 'Spread the "Report invoices to payment gateway" status to ALL ASSOCIATED CLIENTS',
        propagate_ipg_issue_enabled_to_cpgs:
          'If this gateway is associated with any customer, its status will be changed to Enabled/Disabled according to your choice.',
        qr_enabling_process:
          'To enable QR, make sure you have the QR channel enabled in SIRO and then contact Wispro support to complete the process.',
        siro: {
          account_id: 'CUIT Admin',
          auto_confirm: 'Automatically confirm invoices in SIRO',
          cbu_holder: 'Account holder CBU',
          cuit_holder: 'Account holder CUIT',
          merchant_id: 'ID Account',
          qr_enabled: 'Enabled QR',
          reference_prefix: 'Reference prefix',
          required_to_use_qr: 'Required to use QR',
          zip_code: 'Zip Code'
        },
        token_message: 'This token is required by the Facilito team',
        verify_successfully: 'Verify successfully',
        vippo: {
          account_id: 'ViPPO Account',
          merchant_id: 'Branch'
        },
        yappy: {
          account: 'Secret key',
          account_id: 'Secret key',
          api_key: 'API Key',
          api_login: 'Website',
          branch_office: 'Merchant ID',
          integration_api: 'Integration API',
          integration_api_key: 'API Key',
          merchant_id: 'Merchant ID',
          payment_button: 'Payment button',
          seed_code: 'Seed code'
        }
      },
      payment_gateway_transaction: {
        balance_amount: 'Balance amount',
        comision_amount: 'Comision amount',
        date_processed: 'processed at',
        gross_amount: 'Gross amount',
        net_amount: 'Net amount',
        payment: 'Internal Payment',
        transaction: 'Transaction'
      },
      payment_promise: {
        mobile: 'Mobile',
        user_id: 'Creator',
        valid_until: 'Valid until'
      },
      payment_receipt: {
        all: 'All',
        client_bank_name: 'Bank name',
        client_identification_number: 'ID',
        client_name: 'Client name',
        client_phone_number: 'Phone number',
        discarded: 'Discarded',
        // created_at: 'Created at',
        error: 'Error',
        id: 'ID',
        invoice: 'Invoice',
        invoice_number: 'Invoice number',
        invoicing_invoice_id: 'Invoice (ID)',
        invoicing_isp_id: 'ISP (ID)',
        pending: 'Pending',
        processed: 'Processed',
        reference: 'Reference',
        state: 'State',
        updated_at: 'Updated at',
        validating: 'Validating'
      },
      payment_transaction: {
        payment_for: 'Payment for',
        invoicing_abstract_invoice_id: 'Invoice (ID)',
        invoicing_payment_id: 'Payment (ID)'
      },
      plan: {
        auto_invoice_issuing: 'Auto invoice issuing',
        automatic_state: 'Automatic state',
        charge_in_advance: 'Charge in advance',
        days_for_first_due: 'Days to 1º due date',
        days_for_second_due: 'Days to 2º due date',
        days_to_alert_contract: 'Days to alert contract',
        days_to_disable_contract: 'Days to disable contract',
        due_one_interest: 'Interest for 1º due date',
        due_two_interest: 'Interest for 2º due date',
        electronic_enabled: 'Electronic',
        first_surcharge_product_code: 'First due date interest product code',
        frequency: 'Frequency',
        generate_reconnection_charge: 'Generate reconnection charge',
        installation_price: 'Installation price',
        installation_product_code: 'Installation product code',
        installation_tax: 'Installation tax',
        invoicing_isp_id: 'Isp',
        kind_invoice: 'Kind invoice',
        not_invoice_when_is_disabled: 'Not invoice when is disabled',
        propagate_frequency_to_contracts: 'Propagate frequency changes to associated contracts',
        propagate_price_to_contracts: 'Propagate price changes to associated contracts',
        reconnection_charge_product_code: 'Reconnection charge product code',
        second_due_date_at_end_of_period: '2º due date at end of period',
        second_surcharge_product_code: 'Second due date interest product code',
        start_invoicing_date: 'Start invoicing date',
        strategy_to_alert_contract: 'Change state to alerted',
        strategy_to_disable_contract: 'Change state to disabled',
        tax_one: 'Tax',
        tax_one_id: 'Tax',
        taxpayer_identification_number: 'Taxpayer identification number',
        use_information_contract_for_invoice: 'Use information contract for invoice'
      },
      profile: {
        degraded_contract_state_table_hint:
          'Contracts that are degraded will be able to navigate when disabled, but only at a fraction of the plan’s speed',
        with_interest_amount_text: '$ (Amount)',
        with_interest_percentage_text: '% (Percentage)',
        no_interests: 'No interests',
        due_on_days: 'To {{days}} days',
        first_due_date: '1st Due Date',
        second_due_date: '2nd Due Date',
        charge_in_advance_enabled: 'Charge in advance enabled',
        charge_in_advance_disabled: 'Charge in advance disabled',
        auto_invoice_issuing_enabled: 'Automatic issuance enabled',
        auto_invoice_issuing_disabled: 'Automatic issuance disabled',
        not_invoice_when_is_disabled_enabled: 'Do not invoice disabled contracts enabled',
        not_invoice_when_is_disabled_disabled: 'Do not invoice disabled contracts disabled',
        edit_due_date: 'Edit Due Date details',
        alert_contracts: 'Alert',
        alert_contracts_on_due: 'Contracts will be alerted when the invoice reaches the 1st due date',
        alert_contracts_on_days: 'Contracts will be alerted after {{days}} days',
        alert_contracts_on_never: 'Contracts will never be alerted',
        disable_contracts_on_due: 'Contracts will be disabled when the invoice reaches the 2nd due date',
        disable_contracts_on_days: 'Contracts will be disabled after {{days}} days',
        disable_contracts_on_never: 'Contracts will never be disabled',
        disable_contracts: 'Disable',
        delinquent_contracts: 'Delinquent',
        contract_strategy: {
          never_alert: 'Never',
          never_disable: 'Never',
          never_delinquent: 'Never',
          on_first_due_date_alert: 'On first due date',
          on_second_due_date_disable: 'On second due date',
          set_days_alert: 'Pass {{days}} days of first due date',
          set_days_disable: 'Pass {{days}} days of second due date',
          set_days_delinquent: 'Pass {{days}} days of second due date'
        },
        table_headers: {
          when_generate: 'How to interpret the invoice generation date',
          contract_strategy: 'Contracts strategy',
          configuration: {
            title: 'Check whether these functions are <enabledIcon/>enabled or <disabledIcon/>disabled',
            charge_in_advance: {
              enabled_item:
                '<wrapper><enabledIcon/>Billed at the beginning of the period. Due dates start from the first day of the cycle.</wrapper>',
              disabled_item:
                '<wrapper><disabledIcon/>Billed at the end of the period.  Due dates are defined at the end of the period or on the configured days prior.</wrapper>'
            },
            auto_invoice_issuing: {
              enabled_item:
                '<wrapper><enabledIcon/>Once the invoice is generated, the system issues it automatically.</wrapper>',
              disabled_item: '<wrapper><disabledIcon/>The invoice must be issued manually.</wrapper>'
            },
            not_invoice_when_is_disabled: {
              enabled_item:
                '<wrapper><enabledIcon/>If a contract is inactive, no invoice will be generated for the new period.</wrapper>',
              disabled_item: '<wrapper><disabledIcon/>Inactive contracts will also generate invoices.</wrapper>'
            }
          }
        },
        charge_in_advance: 'Charge in advance',
        auto_invoice_issuing: 'Automatic issuance',
        days_before_end_period: 'Days before due date',
        days_for_first_due: 'Days until first due date',
        days_for_second_due: 'Days until second due date',
        days_to_alert_contract: 'Days to alert the contract',
        days_to_disable_contract: 'Days to disable the contract',
        days_to_delinquent_contract: 'Days to delinquent the contract',
        default: 'Default',
        default_profile_description: 'Billing will be done with this profile',
        degraded_state_when_disabled: 'Degrade the service',
        first_due_date_enabled: 'Enable first due date',
        invoice_generation_title: 'Invoice Generation',
        beginning_of_period: 'At the beginning of the period',
        end_of_period: 'At the end of the period',
        days_before_end: 'Select days before the end of the period',
        days_before_end_indicator: 'to {{days}} days before the end of the period',
        current_period: 'Current period',
        next_period: 'Next period',
        never: 'Never',
        on_first_due_date: '1st. Vencimiento',
        on_second_due_date: '2nd. Vencimiento',
        set_days: 'Define days',
        form_hints: {
          default: 'It will appear by default in the contract creation form',
          default_profile: 'The default profile is: <strong>{{profile}}</profile>',
          charge_in_advanced_enabled:
            '<b>Enabled</b> Billed at the beginning of the period. Due dates are set from the first day of the customer’s billing cycle.',
          charge_in_advanced_disabled:
            '<b>Disabled</b> Billed at the end of the period. Due dates are set from the last day of the customer’s billing cycle.',
          invoice_generation_subtitle:
            'When billing at the end of the period, the system can generate the invoice on the following dates:',
          generation_quote: '  <b>Note:</b> The duration of the periods depends on each customer’s billing start date.',
          auto_invoice_issuing: 'Once the invoice is generated by the system, it will be issued automatically',
          not_invoice_when_is_disabled: 'If the contract is inactive, no invoice will be generated for the new period.',
          surcharges_description:
            '<div><b>Tolerance Amount</b><p>Allows invoices that reach the first or second due date to not change the contract status to <i>alerted</i>, <i>degraded</i>, or <i>disabled</i>, if the customer has automatic status enabled and the invoice balance is less than or equal to the tolerance amount.</p></div>',
          surcharges_quote: '<span><b>Note:</b> Amount 0 disables this functionality.</span>',
          strategy_to_invoice_surcharges:
            '<div><SCBlock><b>Next Period:</b> Surcharges generated by due dates will be included in the next contract invoice. Keep in mind that interests are cumulative, and one item will be included in the invoice for each surcharge to be collected.</SCBlock><SCBlock><b>Current Period:</b> Surcharges will be billed in the current period, with one invoice per due date.</SCBlock></div>',
          days_for_first_due:
            'Days that must pass until the first due date (depending on whether the payment is in advance or not).',
          interests:
            '<div>If the <b>interest on the first due date is as an amount</b>, the invoices to be generated will have the value entered.</div><div>If the <b>interest on the first due date is as a percentage</b>, the values must be between 0 (no interest) and 100.</div>',
          interest_first_due_date_as_mount_label:
            '<div><b>Enabled:</b> Interest is defined as a fixed amount.</div><div><b>Disabled:</b> Interest is calculated as a percentage of the total invoice amount.</div>',
          second_due_date_at_end_of_period:
            'The second due date will always be set at the end of the period covered by each invoice generated.',
          days_for_second_due:
            'Days that must pass until the second due date (depending on whether the payment is in advance or not).',
          interests_section:
            "'<div>If the <b>interest on the second due date is as an amount</b>, the invoices to be generated will have the value entered.</div>div>If the <b>interest on the second due date is as a percentage</b>, the values must be between 0 (no interest) and 100.</div><div><b>NOTE:</b> Interest is cumulative.</div>'",
          interest_second_due_date_as_mount:
            '<div><b>Enabled:</b> Interest is defined as a fixed amount.</div><div><b>Disabled:</b> Interest is calculated as a percentage of the total invoice amount.</div>',
          surcharges: 'The connection surcharge will only be generated if the second due date is exceeded.',
          reconnection_charge: 'Gross amount of the reconnection charge',
          interest_as_amount_hint:
            '<div><b>Enabled:</b> Interest is defined as a fixed amount. </div><div><b>Disabled:</b> Interest is calculated as a percentage of the total invoice amount. </div>',
          strategy_to_alert_contracts:
            '<div><b>Never:</b> Use if you never want the system to change the status of contracts to ‘alerted’. </div><div><b>1st due date:</b> When an invoice reaches its 1st due date, the system will change the contract status to ‘alerted’.</div><div><b>Define days:</b> Set how many days after the 1st due date the contract will be alerted.</div>',
          strategy_to_disable_contracts:
            '<div><b>Never:</b> Use if you never want the system to disable contracts. </div><div><b>Define days:</b> Establish how many days after the 2nd due date has been reached the system will change the contract status to ‘disabled’.</div>',
          strategy_to_delinquent_contracts:
            '<div><b>Never:</b> Use if you never want the system to delinquent contracts. </div><div><b>Define days:</b> Establish how many days after the 2nd due date has been reached the system will change the contract to ‘delinquent‘.</div>',
          days_to_disable_contract:
            'Days that must elapse to disable the contract once the second expiration date has been reached',
          days_to_delinquent_contract:
            'Days that must elapse to delinquent the contract once the second expiration date has been reached',
          degraded_state_when_disabled:
            'The contract will allow you to browse the internet, but at a fraction of the speed of the plan.'
        },
        strategy_to_disable_contracts: 'Strategy to disable Contracts',
        strategy_to_delinquent_contracts: 'Strategy to delinquent Contracts',
        strategy_to_alert_contracts: 'Strategy to alert Contracts',
        generate_reconnection_charge: 'Generate reconnection charge',
        interest_first_due_date: 'First due date interest',
        interest_first_due_date_as_mount: 'Fixed amount for interest (1st due date)',
        interest_first_due_date_as_mount_label: 'Enable interest as fixed amount',
        interest_second_due_date: 'Second due date interest',
        interest_second_due_date_as_mount: 'Fixed amount for interest (2nd due date)',
        invoicing_tax_reconnection_charge_id: 'Reconnection charge tax',
        not_invoice_when_is_disabled: 'Do not invoice disabled contracts',
        second_due_date_at_end_of_period: '2nd due date at the end of the period',
        days_to_disable_contract_label: 'Days to disable',
        days_to_delinquent_contract_label: 'Days to delinquent',
        second_due_date_enabled: 'Enable second due date',
        strategy_to_alert_contract: 'Strategy to alert the contract',
        strategy_to_disable_contract: 'Strategy to disable the contract',
        strategy_to_delinquent_contract: 'Strategy to delinquent the contract',
        strategy_to_invoice_surcharges: 'Strategy to invoice surcharges',
        tax_reconnection_charge: 'Reconnection charge tax',
        tolerance_amount: 'Tolerance amount',
        tour: {
          count_info_description:
            'This counter shows how many records are displayed. If you apply a search or filters, you will see the filtered total against the overall total, and with the clear button you can reset and return to the full list.',
          count_info_title: 'Displayed records',
          create_profile_description:
            'With this button you can create a new billing profile. Clicking it will open a form where you’ll enter the necessary data and, once saved, the profile will be available in the list.',
          create_profile_title: 'Create billing profile',
          form_basic_tab_description_left:
            'Fill in the main profile details, such as the name, whether billing will be in advance, and the rules for invoice generation according to the billing period.',
          form_basic_tab_description_right:
            'In this section you can configure automatic invoice issuance, define whether disabled contracts will be invoiced, and set up surcharge rules with their corresponding tolerance amount.',
          form_basic_tab_title_left: 'Basic Tab #1',
          form_basic_tab_title_right: 'Basic Tab #2',
          form_container_description:
            'This is the form to create a new billing profile. It is organized into tabs that we will go through step by step to complete all the required information.',
          form_container_title: 'Form',
          form_due_tab_first_description:
            'Here you define the days until the first due date and, if desired, apply interests either as a fixed amount or as a percentage of the invoice value.',
          form_due_tab_first_title: 'First due date',
          form_due_tab_second_title: 'Second due date',
          form_due_tab_second_title_description:
            'Set the days until the second due date, define if cumulative interests will apply as an amount or percentage, and, if needed, establish a reconnection fee that will be generated once this due date is surpassed.',
          form_strategy_tab_alert_description:
            'Here you define when a contract will move to alerted status. You can set it to happen on the first due date or after a certain number of days, as needed.',
          form_strategy_tab_alert_title: 'To alert contracts',
          form_strategy_tab_disable_description:
            'Set when contracts will be disabled, either at the second due date or after a defined period. You can also enable service degradation so the customer browses at reduced speed instead of being fully deactivated.',
          form_strategy_tab_disable_title: 'To disable contracts',
          table_col_actions_edit_description:
            'Edit any detail of this profile and adjust settings so everything fits your needs.',
          table_col_actions_edit_title: 'Edit Profile',
          table_col_contract_alert_description:
            'Enable this option to receive reminders about contracts close to their first due date. Stay on top of things easily.',
          table_col_contract_alert_title: 'Contract Alerts',
          table_col_contract_disable_description:
            'Manage which contracts are disabled and handle alerts for them based on the second due date.',
          table_col_contract_disable_title: 'Disabled Contracts',
          table_col_contract_info_description:
            'See how many contracts are linked to this profile for a quick overview of your management.',
          table_col_contract_info_title: 'Assigned Contracts',
          table_col_first_due_description:
            'Check when this period is due and the applicable interest. You can also edit it if you need quick adjustments.',
          table_col_first_due_title: 'First Due Date',
          table_col_icons_description:
            'Quickly see if automatic issuance, and invoicing of disabled contracts are active. This way, you’ll know which features are ready to use!',
          table_col_icons_title: 'Billing Configuration',
          table_col_indicators_description:
            'Set the days before due date and the tolerance amount. Customize your alerts and reminders to keep everything under control.',
          table_col_indicators_title: 'Due Date Settings',
          table_col_name_description:
            'Here you’ll see the main details of the billing profile: its identifier, name, creation and update dates, plus an indicator showing if it is marked as default.',
          table_col_name_title: 'Profile Information',
          table_col_second_due_description:
            'View the date and interest of the second due date. Easily modify it if your conditions change.',
          table_col_second_due_title: 'Second Due Date',
          table_col_contract_strategy_title: 'Contract Strategy',
          table_col_contract_strategy_description:
            'Configure how to manage your contracts: receive alerts close to the first expiration date and monitor disabled contracts with notifications based on the second expiration date, all from one place.',
          form_strategy_tab_delinquent_title: 'Mark Contracts as Delinquent',
          form_strategy_tab_delinquent_description:
            'Configure when a contract will be marked as delinquent, either never or after a defined period following the second due date.'
        },
        when_generate: 'When to generate the invoice'
      },

      recurring_item: {
        kind: 'Item',
        lapse: 'Period',
        tax_one: 'Tax',
        tax_one_id: 'Tax',
        invoicing_kind_id: 'Recurring Item Template'
      },
      service_invoice: {
        Amount: 'Total amount',
        auto_invoice_issuing: 'Auto invoice issuing',
        charge_installation: 'Charge installation?',
        from_day: 'From',
        installation_amount: 'Installation amount',
        to_day: 'To'
      },
      tax: {
        code: 'Code',
        rate: 'Rate'
      },
      transaction: {
        abstract_invoice: 'Invoice',
        current_account: 'Current Account',
        invoicing_abstract_invoice_id: 'Invoice',
        invoicing_current_account_id: 'Current Account',
        invoicing_payment_id: 'Payment (ID)',
        payment: 'Payment',
        transaction_kind: 'Payment kind',
        transaction_kind_id: 'Transaction kind (ID)'
      },
      transaction_kind: {
        api_payment: 'API Payment',
        bank_transfer: 'Bank transfer',
        cash: 'Cash',
        check: 'Check',
        cobro_digital_payment: 'CobroDigital',
        credit_card: 'Credit Card',
        credit_note: 'Credit Note',
        cuenta_digital_payment: 'CuentaDigital',
        current_account: 'Current account',
        debit_card: 'Debit Card',
        electronic_transfer: 'Electronic Transfer',
        enabled_for_collector: 'Enabled for Collector',
        invoice: 'Invoice',
        mercado_pago_payment: 'MercadoPago',
        online_payment: 'Online Payment',
        payment_deleted: 'Payment Deleted',
        payu_payment: 'PayU',
        pichincha_payment: 'Pichincha',
        refund: 'Refund',
        service_card: 'Service Card',
        siro_payment: 'Siro',
        unidentified: 'Unidentified',
        wompi_payment: 'Wompi',
        yappy_payment: 'Yappy',
        one_pay_payment: 'OnePay'
      }
    },
    iproute: {
      conflict_ips: 'Conflict DHCP IPs',
      dhcp_enabled: 'Dhcp enabled',
      dhcp_gateway: 'Dhcp gateway',
      dhcp_ranges: 'Dhcp range',
      dst_address: 'Destiny address',
      gateway: 'Gateway',
      interface: 'Interface',
      lease_time: 'Lease time'
    },
    isp: {
      country_name: 'Country',
      gps_location: 'Location',
      invoice_push_notification: 'Invoice push notification',

      mobilephone_number: 'Mobile Phone',
      name: 'ISP name',
      payment_push_notification: 'Payment push notification',
      telephone_number: 'Phone'
    },
    kind_feedback: {
      kind: 'Kind of feedback'
    },
    kind_person: {
      mexico_natural: 'Physic Person',
      mexico_juridic: 'Moral Person'
    },
    nap: {
      create_new_nap: 'Create new NAP',
      fbp: 'Port',
      feasibility_distance: 'Feasibility distance (in meters)',
      massive_update: 'Massive update',
      nap_port: {
        ports_with_contracts: 'with contract',
        ports_without_contracts: 'without contract',
        manage_ports: 'Manage Ports',
        state: {
          free: {
            one: 'Free',
            other: 'Free'
          },
          filled: {
            one: 'Assigned',
            other: 'Assigned'
          },
          available: {
            one: 'Available',
            other: 'Available'
          },
          filled_with_contract: {
            one: 'Filled with contract',
            other: 'Filled with contract'
          },
          filled_without_contract: {
            one: 'Filled without contract',
            other: 'Filled without contract'
          },
          broken: {
            one: 'Broken',
            other: 'Broken'
          }
        }
      },
      seals: {
        state: {
          with_contract: 'with contract',
          without_contract: 'without contract'
        }
      },
      placeholder_basic_search: 'Name, FBP, Olt',
      power_limit: 'Power limit',
      select_nap: 'Should select at least one NAP'
    },
    nas: {
      create_new_nas: 'Create new NAS',
      drag_here: 'Drag boxes here',
      available_agents: 'Available Boxes',
      selected_agents: 'Selected Boxes'
    },
    node: {
      contracts_count: 'Contracts',
      gps_point: 'Gps Point'
    },
    node_device: {
      contracts_count: 'Contracts'
    },
    notification_mail: {
      default_body: 'Default body',
      default_subject: 'Default subject',
      email: 'Reply to',
      first_image: 'First Image',
      lapse: 'Lapse (number)',
      online_changed: 'Status change',
      second_image: 'Second Image',
      unit: 'Time unit'
    },
    notification_web: {
      auto_redirect_interval: 'Auto-redirect interval',
      contract_notifications: 'Contracts',
      default_body: 'Default body',
      from_at: 'From',
      lapse: 'Lapse',
      lapse_time: 'Lapse',
      unit: 'Unit'
    },
    notifications: {
      auto_redirect_interval: 'Auto-redirect interval',
      contracts_seens: 'Contracts/Seens',
      email: 'Reply to',
      from_at: 'From',
      kind_subject: 'Kind - Subject',
      lapse_time: 'Lapse',
      times: 'Times',
      unit: 'Unit'
    },
    ont: {
      admin_status: 'Admin status',
      admin_state: 'Admin state',
      auth_flag: 'Auth flag',
      auth_mode: 'Auth mode',
      aging: 'Aging',
      alarm_policy_profile: 'Alarm policy profile',
      alarm_profile_id: 'Alarm profile ID',
      alive_time: 'Alive time',
      attenuation: 'Attenuation',
      auth_info: 'Authentication (auth mode)',
      auth_info_form: 'Authentication ({{auth_mode}})',
      auth_info_fuse: 'Authentication',
      auth_info_fuse_placeholder: 'Serial Number/LOID/PWD',
      authentic_mode: 'Authentication (Mode)',
      authentication_mode: 'Authentication mode',
      authentic_type: 'Authentication (Type)',
      authorized: 'Authorized',
      authorized_onts: 'Authorized ONUs',
      authorized_onts_linked: 'Authorized ONUs with Contract',
      authorized_onts_not_linked: 'Authorized ONUs not linked',
      auto_replace: 'Auto replace',
      basic_info: 'Basic Info',
      battery_backup: 'Battery backup',
      battery_monitor: 'Battery monitor',
      binding_lan: 'Binding LAN',
      bindinglan: 'Binding LAN',
      binding_ssid: 'Binding SSID',
      bindingssid: 'Binding SSID',
      board: 'Board',
      capa2: 'Layer 2 Information',
      bridge_mode: 'Bridge mode',
      bridge_port_binding: 'Bridge port binding',
      cant_get_info: "Can't get info from the ONU",
      capability_info: 'Capability info',
      catv: 'CATV',
      catv_info_empty: "Can't get onu CATV info, or the ONU not support",
      catv_rx_optical_power: 'CATV RX Power',
      catv_rx_power_alarm_threshold: 'CATV RX Power Alarm Threshold',
      catv_port_off: 'Off',
      catv_port_on: 'On',
      catv_ports_info: 'CATV ports info',
      ces_uni_number: 'CES UNI number',
      chip_info: 'Chip info',
      config_method: 'Config method',
      config_state: 'Config state',
      config_status: 'Config status',
      configure_channel: 'Configure channel',
      connect_mode: 'Connect Mode',
      connect_type: 'Connect type',
      connection_status: 'Connection status',
      connection_type: 'Connection type',
      contract_id_eq: 'Contract',
      control_flag: 'Control flag',
      cos: 'cos',
      cpu_occupation: 'CPU occupation',
      ctc_spc_version: 'CTC spc version',
      cuc_spc_version: 'CUC spc version',
      current_gateway: 'Current gateway',
      current_ip_address: 'Current IP address',
      current_mask: 'Current mask',
      current_primary_dns: 'Current primary DNS',
      current_second_dns: 'Current second DNS',
      date_code: 'Date code',
      dba_mode: 'DBA mode',
      dba_type: 'DBA type',
      default_gateway: 'Default gateway',
      dhcp_enable: 'DHCP enable',
      disable: 'Disabled',
      distance: 'Distance',
      distance_m: 'Distance (m)',
      domain_name: 'Domain name',
      down_priority_queue_number: 'Down priority queue number',
      downstream: 'Downstream',
      downstream_pq_color_policy: 'Downstream PQ color policy',
      ds_lite_mode: 'DS lite mode',
      ds_lite_peer_address: 'DS lite peer address',
      dsp_mode: 'DSP mode',
      enable: 'Enabled',
      encapsulation_type: 'Encapsulation type',
      equipment_id: 'Equipment ID',
      eth: 'ETH',
      ethernet_uni_number: 'Ethernet UNI number',
      exchange: 'Exchange',
      fe: 'Fast Ethernet',
      fec: 'FEC',
      fec_actual_mode: 'FEC actual mode',
      fec_upstream: 'FEC upstream',
      fec_upstream_switch: 'FEC upstream switch',
      frame: 'Frame',
      flow_para: 'Flow param',
      flow_type: 'Flow type',
      frame_slot_port: 'Frame/Slot/Port',
      fs: 'Frame/Slot',
      gateway: 'Gateway',
      ge: 'Gibabit Ethernet',
      gem_port_number: 'GEM port number',
      gemport_id: 'GEM port ID',
      hardware_version: 'Hardware Version',
      host_id: 'Host ID',
      host_name: 'Host name',
      identify: 'Identify',
      iface_name: 'Interface name',
      index: 'Index',
      inner_pri: 'Inner priority',
      inner_vlan: 'Inner VLAN',
      interface_types: 'Port information',
      igmp_proxy: 'IGMP proxy',
      i_pv6_host_number: 'IPV6 host number',
      interoperability_mode: 'Interoperability mode',
      ip_host_number: 'IP host number',
      ip_mode: 'Mode',
      iphost: 'IPHOST',
      ip_addres: 'IP address',
      i_pv4_address: 'IPV4 address',
      i_pv4_access_type: 'IPV4 access type',
      i_pv4_connection_status: 'IPV4 connection status',
      i_pv4_switch: 'IPV4 switch',
      i_pv6_address: 'IPV6 address',
      i_pv6_address_access_mode: 'IPV6 address access mode',
      i_pv6_address_preferred_time: 'IPV6 address preferred time',
      i_pv6_address_status: 'IPV6 address status',
      i_pv6_address_valid_time: 'IPV6 address valid time',
      i_pv6_connection_status: 'IPV6 connection status',
      i_pv6_switch: 'IPV6 switch',
      ipv4_address: 'IPV4 address',
      ipv4_gateway: 'IPV4 gateway',
      ipv4_mask: 'IPV4 mask',
      ipv4_primary_dns: 'IPV4 primary DNS',
      ipv4_secondary_dns: 'IPV4 secondary DNS',
      ipv6_host_number: 'IPV6 host number',
      isolation_state: 'Isolation state',
      l2_encap_type: 'L2 encapsulation type',
      laser_bias_current: 'Laser bias current',
      last_dereg_reason: 'Last deregistered reason',
      last_dereg_time: 'Last deregistered time',
      last_deregist_reason: 'Last deregistered reason',
      last_distance: 'Last distance obtained',
      last_down_cause: 'Last down cause',
      last_down_time: 'Last down time',
      last_dying_gasp: 'Last dying gasp',
      last_dying_gasp_time: 'Last dying gasp time',
      last_offline_time: 'Last offline time',
      last_online_time: 'Last online time',
      last_reg_time: 'Last registered time',
      last_up_time: 'Last up time',
      line_profile: 'Line profile',
      line_profile_id: 'Line profile ID',
      line_profile_name: 'Line profile name',
      llid: 'LLID',
      loid: 'Loid',
      loid_pwd: 'Loid password',
      mac_address: 'MAC address',
      mac_address_i_cont: 'MAC Address',
      mac_aging_time: 'MAC aging time',
      mac_learning_function_switch: 'MAC learning function switch',
      mac_learning_switch: 'MAC learning switch',
      main_software_is_active: 'Main software is active',
      main_software_is_commit: 'Main software is commit',
      main_software_version: 'Main software version',
      manage_priority: 'Manage priority',
      manage_vlan: 'Manage VLAN',
      management_mode: 'Management mode',
      master_dns: 'DNS 1',
      mask: 'Mask',
      match_state: 'Match state',
      mapping_mode: 'Mapping mode',
      memory_occupation: 'Memory occupation',
      moca: 'MoCA',
      module_type: 'Module type',
      module_sub_type: 'Module sub type',
      mtu: 'MTU',
      multillid: 'Multi LLID',
      multicast_encryption: 'Multicast encryption',
      multicast_forward_mode: 'Multicast forward mode',
      multicast_forward_vlan: 'Multicast forward vlan',
      multicast_mode: 'Multicast mode',
      muticast_vlan: 'Muticast Vlan',
      nat_enable: 'NAT?',
      native_vlan_option: 'Native vlan option',
      netmask: 'Netmask',
      number_of_catv_uni_ports: 'CATV UNI ports number',
      number_of_catv_ports: 'CATV ports number',
      number_of_eth_ports: 'ETH ports number',
      number_of_fe_ports: 'FE ports number',
      number_of_ge_ports: 'GE ports number',
      number_of_gem_ports: 'GEM ports number',
      number_of_iphost: 'IPHOSTs number',
      number_of_pots_ports: 'POTS ports number',
      number_of_t_con_ts: 'T-CONTs number',
      number_of_uplink_pon_ports: 'Uplink PON ports number',
      number_of_veip: 'VEIPs number',
      number_of_veip_ports: 'VEIP ports number',
      number_of_xge_ports: 'XGE ports number',
      number_of_wlan_ports: 'WLAN ports number',
      onts_count: 'Displaying {{count}} ONUs',
      omcc_encrypt: 'OMCC encrypt',
      omcc_encrypt_switch: 'OMCC encrypt switch',
      omcc_version: 'OMCC version',
      omci_bw_profile: 'OMCI BW profile',
      on_line_time: 'Online time',
      online_time: 'Online time',
      operator_id: 'Operator ID',
      option60: 'Option 60',
      online: 'Online',
      offline: 'Offline',
      offline_reason: 'Offline reason',
      ont_battery_state: 'ONU battery state',
      ont_id: 'ONU ID',
      ont_ip_address_mask: 'ONU IP address mask',
      ont_product_description: 'ONU product description',
      ont_transparent_function_switch: 'ONU transparent function switch',
      ont_type: 'ONU Type',
      ont_version: 'ONU version',
      onts_status: 'Onts state',
      onu_id: 'ONU ID',
      onu_identifier: 'ONU ID',
      onu_info: 'ONU Info',
      onu_model: 'ONU model',
      onu_nni_port_id: 'ONU NNI port ID',
      onu_profile: 'ONU profile',
      onu_status: 'ONU status',
      onu_type: 'ONU Type',
      onus_by_pon_port: 'Number of ONUs by port',
      onus_with_contract: 'With contracts',
      onus_without_contract: 'Without contracts',
      operate_status: 'Operate status',
      operation_id: 'Operation ID',
      optical_info: 'Optical Info',
      optical_power_precision: 'Optical power precision',
      phase_state: 'Phase state',
      nap_port: 'NAP Port',
      ping_response: 'Ping response',
      pon: 'Uplink PON',
      pon_if_number: 'PONIF Count',
      port_identifier: 'Port ID',
      port_identifier_eq: 'Port ID',
      ports: 'Ports',
      ports_numbers: 'Ports Count',
      pots: 'POTS',
      pots_uni_number: 'POTS UNI number',
      pppoe_mode: 'PPPoE mode',
      pppoe_proxy: 'PPPoE proxy',
      pppoe_service_name: 'PPPoE service name',
      pppoe_serv_name: 'PPPoE serv name',
      pps_to_d: 'PPS to D',
      prefix_access_mode: 'Prefix access mode',
      prefix_preferred_time: 'Prefix preferred time',
      prefix_valid_time: 'Prefix valid time',
      pri_profile_id: 'Pri profile ID',
      primary_dns: 'Primary DNS',
      priority_policy: 'Priority policy',
      product_code: 'Product code',
      product_id: 'Producto ID',
      product_sn: 'Product serial number',
      profiles_info: 'Profiles info',
      protection_type: 'Protection type',
      qinq_enable: 'QinQ?',
      qos_enable: 'QoS?',
      qosenable: 'QoS?',
      qos_mode: 'QoS mode',
      region_code: 'Region code',
      registration_info: 'Registration information',
      ring_check_switch: 'Ring check switch',
      ring_check_detect_frequency: 'Ring check detect frequency',
      ring_detect_frequency: 'Ring detect frequency',
      ring_port_auto_shutdown: 'Ring port auto shutdown',
      ring_resume_interval: 'Ring resume interval',
      rtt: 'RTT',
      rtt_tq: 'RTT',
      run_state: 'Run state',
      rx_power: 'RX Power',
      rx_power_current_alarm_threshold: 'RX power current alarm threshold',
      rx_power_current_warning_threshold: 'RX power current warning threshold',
      rx_optical_power: 'RX Power',
      second_dns: 'Secondary DNS',
      security_capability: 'Security capability',
      security_mode: 'Security mode',
      serial: 'Serial number',
      serial_number: 'Serial number',
      serial_number_i_cont: 'Serial number',
      service_profile: 'Service profile',
      service_profile_id: 'Service profile ID',
      service_profile_name: 'Service profile name',
      slave_dns: 'DNS 2',
      slot: 'Slot',
      slot_number: 'Slot Count',
      service_type: 'Service type',
      sn: 'Serial number',
      sn_bind: 'SN bind',
      software_version: 'Software Version',
      software_work_mode: 'Software work mode',
      standby_software_is_active: 'Standby software is active',
      standby_software_is_commit: 'Standby software is commit',
      standby_software_version: 'Standby software version',
      supply_voltage: 'Supply Voltage',
      supply_voltage_alarm_threshold: 'Supply voltage alarm threshold',
      supply_voltage_warning_threshold: 'Supply voltage warning threshold',
      support_xml_version: 'Support XML version',
      subnet_mask: 'Subnet mask',
      survival_time: 'Survival time',
      switch: 'Switch',
      sysuptime: 'SysUp Time',
      tag_action: 'Tag action',
      t_cont_0_dba_profile_id: 'TCONT 0 DBA profile ID',
      t_cont_1_dba_profile_id: 'TCONT 1 DBA profile ID',
      tcont_number: 'TCONT number',
      tdm: 'TDM',
      tdm_port_type: 'TDM port type',
      tdm_service_type: 'TDM service type',
      temperature: 'Temperature',
      temperature_alarm_threshold: 'Temperature alarm threshold',
      temperature_warning_threshold: 'Temperature warning threshold',
      the_type_of_flow_control: 'Flow control type',
      total_priority_queue_num: 'Total priority queue num',
      total_priority_queue_number: 'Total priority queue number',
      total_traffic_schedule_num: 'Total traffic schedule num',
      total_uni_number: 'Total UNI number',
      totalgemportnum: 'Total GEM port number',
      tr069_ip_index: 'TR069 IP index',
      tr069_management: 'TR069',
      tr069_profile: 'TR069 profile',
      traceroute_response: 'Traceroute response',
      traffic_management_option: 'Traffic management option',
      traffic_profile_id: 'Traffic profile ID',
      traffic_profile_name: 'Traffic profile name',
      traffic_profile_pir: 'Traffic profile PIR',
      traffic_scheduler_number: 'Traffic scheduler number',
      tx_bias_current: 'TX Bias Current',
      tx_bias_current_warning_threshold: 'TX bias current warning threshold',
      tx_bias_current_alarm_threshold: 'TX bias current alarm threshold',
      tx_power: 'TX Power',
      tx_power_current_alarm_threshold: 'TX power current alarm threshold',
      tx_power_current_warning_threshold: 'TX power current warning threshold',
      tx_optical_power: 'TX Power',
      tx_power_supply_control: 'TX power supply control',
      type_c_support: 'Type C support',
      unauthorized_onts: 'Unauthorized ONUs',
      up_priority_queue_number: 'Up priority queue number',
      upgrade: 'Upgrade',
      upstream: 'Upstream',
      upstream_igmp_packet_forward_mode: 'Upstream IGMP packet forward mode',
      upstream_igmp_packet_priority: 'Upstream IGMP packet priority',
      upstream_igmp_packet_forward_vlan: 'Upstream IGMP packet forward vlan',
      upstream_pq_color_policy: 'Upstream PQ color policy',
      used_type: 'Used type',
      validity_mode: 'Validity mode',
      vdsl: 'VDSL',
      veip: 'VEIP',
      veip_number: 'VEIP number',
      veip_uni_number: 'VEIP UNI number',
      vendor_id: 'Vendor ID',
      vendor_name: 'Vendor name',
      vendor_pn: 'Vendor PN',
      vendor_rev: 'Vendor rev',
      vendor_sn: 'Vendor SN',
      video_uni_number: 'Video UNI number',
      vlan: 'Vlan',
      vlans: 'Vlans',
      vlan_cos: 'Vlan cos',
      vlan_id: 'Vlan ID',
      vlan_identifier_eq: 'Vlan',
      vlan_lines: 'Vlan ID Server <=> Client',
      vlan_mode: 'Vlan Mode',
      vlan_priority: 'Vlan priority',
      vo_ip_configure_method: 'VoIP configure method',
      vport_mode: 'Vport mode',
      voltage: 'Voltage',
      wan_conn_mode: 'Wan conn mode',
      wan_conn_type: 'Wan conn type',
      wan_cos: 'Wan cos',
      wan_gateway: 'Wan gateway',
      wan_id: 'WAN ID',
      wan_info: 'Wan',
      wan_ip_address: 'Wan ip address',
      wan_ip_netmask: 'Wan ip netmask',
      wan_master_dns: 'Wan master dns',
      wan_mode: 'Wan Mode',
      wan_mtu: 'Wan MTU',
      wanmtu: 'Wan MTU',
      wan_name: 'Wan name',
      wan_nat_enable: 'Wan NAT enable',
      wan_profile_id: 'WAN profile ID',
      wan_slave_dns: 'Wan slave dns',
      wan_status: 'Wan status',
      wan_vlan_id: 'Wan Vlan id',
      wifi_uni_number: 'WiFi UNI number',
      x_dsl_uni_number: 'xDSL UNI number',
      xdsl_uni_number: 'xDSL UNI number',
      xge: '10 Gigabit Ethernet',
      link_ont_message:
        'When linking a Contract to an ONU, no changes will be made to the OLT and the current configuration will be maintained. You will not be able to perform Bandwidth Control and WAN provisioning actions.',
      reconfigure_ont_message:
        'When overwriting configuration, the ONU will be unauthorized and will be re-authorized and reconfigured with all information set in the Contract.'
    },
    olt: {
      alarm_power_threshold: 'Alarm power threshold dBm',
      allow_only_allowed_contracts_to_navigate: 'Disable ONUs from disabled contracts',
      brand: 'Brand',
      brand_eq: 'Brand',
      catv_control_enabled: 'CATV Control',
      cron_stats_enabled: 'Cron Enabled',
      dns_first_server: 'DNS first server',
      dns_second_server: 'DNS second server',
      equipment_model: 'Model',
      equipment_model_eq: 'Model',
      extra_vlans: 'Extra Vlans',
      fiber_id: 'Fiber (ID)',
      host: 'Host',
      host_cont: 'Host',
      kind: 'OLT Type',
      kind_eq: 'OLT Type',
      name: 'Name',
      navigation_vlan: 'Vlan',
      olt_wan_provisioning: 'WAN provisioning',
      ont_custom_tr069_profile: 'TR069 Profile',
      ont_custom_tr069_profile_hint: 'Write the profile-name of the TR069 Profile to use.',
      onts_consumption_enabled: 'Enable contract graphs',
      pass: 'Pass',
      port: 'Port',
      port_cont: 'Port',
      private_host: 'Private host',
      rx_power_critical_lower: 'RX power critical lower',
      rx_power_critical_upper: 'RX power critical upper',
      rx_power_warning_lower: 'RX power warning lower',
      rx_power_warning_upper: 'RX power warning upper',
      snmp_consumption_enabled: 'Enable consumption graphs',
      snmp_port: 'SNMP Port',
      ssh_port: 'SSH Port',
      state_eq: 'State',
      state_eq_both: 'Both',
      state_eq_free: 'Not Linked',
      state_eq_linked: 'Linked',
      stats_user: 'User stats',
      telnet_port: 'Telnet Port',
      tr069_profile: 'TR069 Profile',
      traffic_control_enabled: 'Traffic control enabled',
      zoneables_zone_ids: 'Zone'
    },
    olt_server_interfaces: {
      olt_id_eq: 'OLT',
      server_configuration_id_eq: 'Server',
      vlan_id_eq: 'VLAN'
    },
    orders: {
      order: {
        end_at: 'End at',
        kinds: {
          installation: 'Installation',
          technical: 'Technical',
          resignation: 'Resignation',
          maintenance: 'Maintenance',
          feasibility: 'Feasibility'
        },
        start_at: 'Start at',
        states: {
          pending: 'Pending',
          to_reschedule: 'To reschedule',
          finalized: 'Finalized',
          closed: 'Closed'
        },
        result: 'Result',
        results: {
          success: 'Success',
          failure: 'Failure'
        }
      }
    },
    owner: {
      last_name: 'Last name',
      payment_by_transfer: 'Payment by transfer',
      payment_on_account: 'Payment on account',
      referral_payment_details: 'Payment details (Referral)',
      referral_payment_method: 'Payment method (Referral)',
      referral_payment_preferences: 'Payment preferences (Referral)',
      referred_by: 'Referral code',
      unspecified: 'Unspecified'
    },
    payment_method: {
      counted: 'Counted',
      credit: 'Credit',
      credit_visa: 'Credit Visa',
      debit_visa: 'Debit Visa',
      deferred_or_installments_payment: 'PPD - Pago en parcialidades o diferido',
      mastercard: 'MasterCard',
      other: 'Other',
      single_payment: 'PUE - Pago en una sola exhibición'
    },
    payment_promise: {
      expiration_filter_expired: 'Expired',
      expiration_filter_not_expired: 'Valid',
      expiration_filter_both: 'Both',
      mobile_filter_mobile: 'AppMobile',
      mobile_filter_not_mobile: 'WisproCloud / API',
      mobile_filter_both: 'Both',
      created_at_gteq: 'Created At (from)',
      created_at_lteq: 'Created At (to)',
      creator_name: 'Creator',
      creator_clients: 'Creator (Clients from AppMobile)',
      creator_users: 'Creator (Employees/Owner)',
      expiration_filter: 'Status',
      mobile_filter: 'Created from',
      placeholder_creator_clients: 'You can select Clients',
      placeholder_creator_users: 'You can select Employees/Owner',
      user_id_eq: 'Creator',
      valid_until: 'Valid until',
      valid_until_gteq: 'Valid (from)',
      valid_until_lteq: 'Valid (to)'
    },
    payment_way: {
      peru: {
        down_payment: '001 - Down payment',
        remittance: '002 - Remittance',
        transfer_of_funds: '003 - Transfer of funds',
        payment_order: '004 - Payment order',
        debit_card: '005 - Debit card',
        credit_card: '006 - Credit card',
        check: '007 - Check',
        cash: '009 - Cash',
        other: '999 - Other payment form'
      },
      mexico: {
        cash: '01 - Efectivo',
        nominal_check: '02 - Cheque nominativo',
        electronic_transfer: '03 - Transferencia electrónica de fondos',
        credit_card: '04 - Tarjeta de crédito',
        debit_card: '28 - Tarjeta de débito',
        to_define: '99 - Por definir'
      },
      ecuador: {
        without_financial_system: '01 - Without financial system',
        debt_compensation: '15 - Debt compensation',
        debit_card: '16 - Debit card',
        electronic_money: '17 - Electronic money',
        prepaid_card: '18 - Prepaid card',
        credit_card: '19 - Credit card',
        others_with_financial_system: '20 - Others with financial system',
        title_endorsement: '21 - Title endorsement'
      },
      colombia: {
        undefined_instrument: '1 - Undefined instrument',
        ach_credit: '2 - Credit ACH',
        ach_debit: '3 - Debit ACH',
        ach_demand_debit_reversal: '4 - Demand debit reversal ACH',
        ach_demand_credit_reversal: '5 - Demand credit reversal ACH',
        ach_demand_debit: '6 - Demand debit ACH',
        ach_demand_credit: '7 - Demand credit ACH',
        hold: '8 - Hold',
        national_or_regional_clearing: '9 - National or regional clearing',
        cash: '10 - Cash',
        reversal_credit_savings: '11 - Reversal credit savings',
        reversal_debit_savings: '12 - reversal debit savings',
        credit_savings: '13 - Credit savings',
        debit_savings: '14 - Debit savings',
        bookentry_credit: '15 - Bookentry credit',
        bookentry_debit: '16 - Bookentry debit',
        // concentration_of_demand_in_cash_disbursement_credit: '17 - Concentration of demand in cash disbursement credit',
        concentration_of_demand_in_cash_disbursement_credit: '18 - Concentration of demand in cash disbursement credit',
        corporate_business_payment_credit: '19 - Corporate business payment credit',
        check: '20 - Check',
        banking_project: '21 - Banking project',
        certified_bank_project: '22 - Certified bank project',
        bank_check: '23 - Bank check',
        Foreign_exchange_note_awaiting_acceptance: '24 - Foreign exchange note awaiting acceptance',
        certified_check: '25 - Certified check',
        local_check: '26 - Local check',
        debit_payment_corporate_business: '27 - Debit payment corporate business',
        credit_business_corporate_exchange: '28 - Credit business corporate exchange',
        debit_business_exchange_corporate: '29 - Debit business exchange corporate',
        credit_transfer: '30 - Credit transfer',
        debit_transfer: '31 - Debit transfer',
        concentration_cash_disbursement_credit_plus: '32 - Concentration cash disbursement credit plus',
        concentration_cash_disbursement_debit_plus: '33 - Concentration cash disbursement debit plus',
        pre_agreed_payment_and_deposit: '34 - Pre agreed payment and deposit',
        cash_concentration_savings_credit_disbursement: '35 - Cash concentration savings credit disbursement',
        cash_concentration_savings_debit_disbursement: '36 - Cash concentration savings debit disbursement',
        payment_corporate_business_savings_credit: '37 - Payment corporate business savings credit',
        payment_corporate_business_savings_debit: '38 - Payment corporate business savings debit',
        corporate_exchange_business_credit: '39 - Corporate exchange business credit',
        corporate_exchange_business_debit: '40 - Corporate exchange business debit',
        cash_concentration_credit_disbursement_plus: '41 - Cash concentration credit disbursement plus',
        cash_concentration_debit_disbursement_plus: '42 - Cash concentration debit disbursement plus',
        bank_deposit: '43 - Bank deposit',
        note_would_exchange: '44 - Note would exchange',
        bank_credit_transfer: '45 - Bank credit transfer',
        interbank_debit_transfer: '46 - Interbank debit transfer',
        bank_debit_transfer: '47 - Bank debit transfer',
        credit_card: '48 - Credit card',
        debit_card: '49 - Debit card',
        post_spin: '50 - Post spin',
        french_banking_standard_telex: '51 - French banking standard telex',
        urgent_business_payment: '52 - Urgent business payment',
        urgent_treasury_payment: '53 - Urgent treasury payment',
        promissory_note: '60 - Promissory note',
        promissory_note_signed_by_the_creditor: '61 - Promissory note signed by the creditor',
        promissory_note_signed_by_the_creditor_guaranteed_by_the_bank:
          '62 - Promissory note signed by the creditor guaranteed by the bank',
        promissory_note_signed_by_the_creditor_endorsed_by_third:
          '63 - promissory note signed by the creditor endorsed by third',
        promissory_note_signed_by_the_bank: '64 - Promissory note signed by the bank',
        promissory_note_signed_by_bank_guaranteed_by_another_bank:
          '65 - Promissory note signed by bank guaranteed by another bank',
        signed_promissory_note: '66 - Signed promissory note',
        promissory_note_signed_by_a_third_party_endorsed_by_bank:
          '67 - Promissory note signed by a third party endorsed by bank',
        withdrawal_of_note_by_the_creditor: '70 - Withdrawal of note by the creditor',
        bonuses: '71 - Bonuses',
        vouchers: '72 - Vouchers',
        withdrawal_of_note_by_the_creditor_on_bank: '74 - withdrawal of note by the creditor on bank',
        withdrawal_of_note_by_the_creditor_guaranteed_by_another_bank:
          '75 - Withdrawal of note by the creditor guaranteed by another bank',
        Withdrawal_of_note_by_the_creditor_on_bank_guaranteed_by_third_party:
          '76 - Withdrawal of note by the creditor on bank guaranteed by third party',
        withdrawal_of_note_by_the_creditor_on_third_party: '77 - withdrawal of note by the creditor on third party',
        withdrawal_of_note_by_the_treditor_on_third_party_guaranteed_by_bank:
          '78 - Withdrawal of note by the treditor on third party guaranteed by bank',
        transferable_bank_note: '91 - Transferable bank note',
        local_transferable_check: '92 - Local transferable check',
        referenced_turn: '93 - Referenced turn',
        urgent_turn: '94 - Urgent turn',
        open_format_turn: '95 - Open format turn',
        requested_payment_method_not_used: '96 - Requested payment method not used',
        clearing_between_partners: '97 - Clearing between partners',
        mutual_agreement: 'ZZZ - Mutual agreement'
      }
    },
    plan: {
      no_policy_to_edit: 'You do not have permission to edit the contract',
      no_policy_to_audits: 'You do not have permission to see the audits',
      app_visibility: 'App Visibility',
      burst_down: 'burst DOWN',
      burst_enable: 'Burst enabled',
      burst_enabled: 'Burst enabled',
      burst_enabled_eq_both: 'Both',
      burst_enabled_eq_disabled: 'Disabled',
      burst_enabled_eq_enabled: 'Enabled',
      burst_limit: 'Burst limit',
      burst_limit_down: 'Burst limit DOWN',
      burst_limit_down_human: 'Burst limit DOWN',
      burst_limit_down_unit: 'Burst limit DOWN',
      burst_limit_up: 'Burst limit UP',
      burst_limit_up_human: 'Burst limit UP',
      burst_limit_up_unit: 'Burst limit UP',
      burst_threshold_down: 'Burst threshold DOWN',
      burst_threshold_down_human: 'Burst threshold DOWN',
      burst_threshold_down_unit: 'Burst threshold DOWN',
      burst_threshold_up: 'Burst threshold UP',
      burst_threshold_up_human: 'Burst threshold UP',
      burst_threshold_up_unit: 'Burst threshold UP',
      burst_time_down: 'Burst time DOWN',
      burst_time_up: 'Burst time UP',
      burst_up: 'Burst UP',
      ceil: 'Máx. Upload / Máx. Download',
      ceil_down: 'Máx. Download',
      ceil_down_human: 'Máx. Download',
      ceil_down_unit: 'Download unit',
      ceil_up: 'Máx. Upload',
      ceil_up_human: 'Máx. Upload',
      ceil_up_unit: 'Upload unit',
      cir_percentage: 'Percentage value',
      cir_strategy: 'Strategy for guaranteed bandwith',
      cir_strategy_eq_automatic: 'Automatic',
      cir_strategy_eq_both: 'Both',
      cir_strategy_eq_percentage: 'Percentage',
      cir_strategy_percentage: 'Percentage',
      clock_control: 'Clock control',
      degraded_percent: 'Degraded percentage',
      down: 'DOWN',
      invoicing_plan_attributes: {
        first_surcharge_product_code: 'First due date interest product code',
        installation_price: 'Installation price',
        installation_product_code: 'Installation product code',
        invoicing_frecuency: {
          ['1']: 'Monthly',
          ['2']: 'Bimonthly',
          ['3']: 'Every three months',
          ['4']: 'Quarterly',
          ['6']: 'Semiannual ',
          ['12']: 'Annual'
        },
        price: 'Price',
        product_code: 'Product code',
        reconnection_charge_product_code: 'Reconnection charge product code',
        second_surcharge_product_code: 'Second due date interest product code'
      },
      long_download_max: 'Large donwloads limit[kbytes]',
      long_upload_max: 'Large uploads limit[kbytes]',
      mikrotik_cir: 'CIR',
      mikrotik_strategy: 'Bandwith strategy',
      mikrotik_strategy_eq_all: 'All',
      mikrotik_strategy_eq_pcq_with_queue_tree: 'PCQ with queue tree',
      mikrotik_strategy_eq_pcq_with_simple_queue: 'PCQ with simple queue',
      mikrotik_strategy_eq_simple_queue: 'Simple Queue',
      number_of_contracts: 'Number of contracts',
      public_for_mobile_eq_both: 'Both',
      public_for_mobile_eq_disabled: 'Disabled',
      public_for_mobile_eq_enabled: 'Enabled',
      rate_down: 'Min. Download',
      rate_up: 'Min. Upload',
      simple_queue: 'Simple Queue',
      simple_queue_with_cake: 'Simple queue with cake',
      simple_queue_with_cake_warning: 'Caution: using single queues with cake results in higher RAM consumption',
      strategy_bandwidth: 'Strategy for guaranteed bandwith',
      tax_one_id: 'Tax',
      time_ceil_down: 'Máx. Download',
      time_ceil_down_human: 'Máx. Download',
      time_ceil_down_unit: 'Máx. Download',
      time_ceil_up: 'Max. Upload',
      time_ceil_up_human: 'Max. Upload',
      time_ceil_up_unit: 'Upload unit',
      time_enabled: 'Time control enabled',
      time_enabled_eq_both: 'Both',
      time_enabled_eq_disabled: 'Disabled',
      time_enabled_eq_enabled: 'Enabled',
      time_friday: 'friday',
      time_from: 'From',
      time_monday: 'monday',
      time_saturday: 'saturday',
      time_sunday: 'sunday',
      time_thursday: 'thursday',
      time_to: 'To',
      time_tuesday: 'tuesday',
      time_wednesday: 'wednesday',
      title_burst_down: 'Burst UP',
      title_burst_up: 'Burst DOWN',
      title_invoicing: 'Invoicing',
      tool_tips: {
        burst_duration: 'Duration of up burst (Seconds)',
        burst_limit_down: 'Maximum data download speed that can be achieved while bursting is enabled',
        burst_limit_up: 'Maximum load data rate that can be achieved while bursting is allowed',
        burst_threshold_down: 'This is the discharge burst on/off value',
        burst_threshold_up: 'This is the on/off value of load burst',
        burst_time_down:
          'Time period, in seconds, during which the average download data rate is calculated (this is NOT the time of the actual burst).',
        burst_time_up:
          'Time period, in seconds, during which the average load data rate is calculated (this is NOT the time of the actual burst).',
        cir: 'Percentage of bandwidth to be guaranteed to each contract',
        cir_strategy_bmu: 'Strategy to be used for bandwidth strategy',
        mikrotik_cir: 'Percentage of bandwidth to be guaranteed to each contract',
        mikrotik_strategy: 'Strategy to be used for bandwidth allocation',
        total_contracts_bmu: 'Total contracts assigned Bmu',
        total_contracts_mikrotik: 'Total contracts assigned to Mikrotik'
      },
      unlimited: 'Unlimited',
      up: 'UP',
      week: {
        time_friday: 'Friday',
        time_monday: 'Monday',
        time_saturday: 'Saturday',
        time_sunday: 'Sunday',
        time_thursday: 'Thursday',
        time_tuesday: 'Tuesday',
        time_wednesday: 'Wednesday'
      },
      week_indication: 'You must select the day or days on which you want the time control to start.'
    },
    portal_configuration: {
      change_plan_mobile_setting: 'Change plan from the mobile app.',
      company_isotype_title: 'ISP Isotype',
      contract_alerted_sms_notification: 'Notification SMS contract alerted',
      contract_disabled_sms_notification: 'Notification SMS contract disabled',
      contract_graphs_enabled: 'Contract graphs',
      create_issue_mobile_setting: 'Create tickets from the mobile app.',
      create_payment_promise_mobile_setting: 'Create payment promises from the mobile app.',
      disabled_contract_push_notification: 'Notification mobile disabled contract',
      email: 'Email',
      enabled: 'Client portal state',
      finalized_issue_push_notification: 'Notification mobile finalized issue',
      first_due_date_invoice_push_notification: 'Notification mobile first due date',
      issue_invoice_push_notification: 'Notification mobile issued invoice',
      issued_invoice_sms_notification: 'Notification SMS issued invoice',
      locale: 'en',
      new_payment_push_notification: 'Notification mobile new payment',
      phone: 'Telephone number',
      phone_mobile: 'Mobile phone number',
      portal_logo: 'Portal Logo',
      portal_logo_title: 'Portal Logo',
      second_due_date_invoice_push_notification: 'Notification mobile second due date',
      telegram_phone: 'Telegram',
      whatsapp_phone: 'Whatsapp',
      wifi_mobile_setting: 'Visualize Wi-Fi settings from the mobile app.'
    },
    ppp_profile: {
      lan_prefixes_dhcpv6_pd_pool: 'Lan Prefixes(DHCPv6 PD Pool)',
      wan_prefixes_remote_ipv6: 'Wan Prefixes (Remote IPv6 Prefix Pool)',
      ceil_down_human: 'Ceil down',
      ceil_down_unit: 'Max. download unit',
      ceil_up_human: 'Ceil up',
      ceil_up_unit: 'Max. upload unit',
      custom_ceil_down: 'Ceil down',
      custom_ceil_up: 'Ceil up',
      mikrotik_dns_server_one: 'Dns Server one',
      mikrotik_dns_server_three: 'Dns Server three',
      mikrotik_dns_server_two: 'Dns Server two',
      server_configuration_id: 'Server',
      use_rate_limit: 'Use rate limit'
    },
    provider: {
      online: 'Online',
      online_changed_at: 'Online changed at',
      rate_down: 'Download',
      rate_up: 'Upload'
    },
    provider_group: {
      providers: 'Providers',
      rate_down: 'Download',
      rate_download: 'Download',
      rate_up: 'Upload',
      simultaneity_down_index: 'Down index',
      simultaneity_up_index: 'Up index'
    },
    push_notification_device: {
      add_all_clients: 'Add All',
      add_clients: 'Add Clients',
      clients_selected: 'Clients Selected',
      confirm_add_all: 'Add All',
      confirm_add_selected: 'Add Selected',
      confirm_remove_all: 'Remove All',
      confirm_remove_selected: 'Remove Selected',
      custom_no_record_message_add: 'There are no Clients available to add',
      custom_no_record_message_remove: 'There are no Clients available to remove',
      description: 'Description',
      destroy_clients: 'Delete Clients',
      destroy_filtered_clients: 'Delete',
      detail: 'Detail',
      disabled_contract_push_notification: 'Disabled Contract',
      dual_list: {
        hint: 'Only clients with the Application Alerta Internet installed will be displayed.'
      },
      edit_notification_mobile: 'Edit Notification',
      error_message: 'There is not any notification to show',
      existing: 'Existing',
      filter: {
        default_pending_invoices: 'Both',
        title: 'Filter by Status',
        with_pending_invoices: 'Debtors',
        without_pending_invoices: 'No Debt'
      },
      filter_placeholder: 'Clients Name',
      filter_typeahead_placeholder: 'Filter by Name',
      finalized_issue_push_notification: 'Finalized Issue',
      first_due_date_invoice_push_notification: 'First Due Date',
      form: {
        hint: 'Once the notification is created you will have 15 minutes to edit or delete it,then it will be sent.' // title: 'Title'
      },
      hint: {
        disabled_contract_push_notification:
          'Each time a contract is disabled in the system a notification will be sent to the client',
        finalized_issue_push_notification:
          'Each time an issue is finalized in the system a notification will be sent to the client',
        first_due_date_invoice_push_notification:
          'Each time the first due date of an invoice is reached a notification will be sent to the client.',
        issue_invoice_push_notification:
          'Each time an invoice is issued in the system a notification will be sent to the client.',
        kind: 'Event',
        new_payment_push_notification:
          'Each time a payment is loaded into the system a notification will be sent to the client.',
        second_due_date_invoice_push_notification:
          'Each time the second due date of an invoice is reached a notification will be sent to the client.'
      },
      invoice_push_notification: 'Issued Invoice',
      is_pending_message: 'Your information is being processed',
      issue_invoice_push_notification: 'Issued Invoice',
      kind: 'Event',
      label_state: {
        failure: {
          one: 'Failure',
          other: 'Failures'
        },
        pending: {
          one: 'Pending',
          other: 'Pendings'
        },
        success: {
          one: 'Success',
          other: 'Successfuly'
        }
      },
      manage_clients: 'Manage Clients',
      new_notification_mobile: 'New Notification',
      new_payment_push_notification: 'New Payment',
      notification_placeholder: 'Title, Detail',
      payment_push_notification: 'New Payment',
      placeholder_contracts_coverage_node_id_eq: 'Node',
      placeholder_contracts_plan_id_eq: 'Plan',
      placeholder_contracts_server_configuration_id_eq: 'Server',
      placeholder_invoicing_client_invoicing_firm_id_eq: 'Invoicing Firm',
      placeholder_neighborhood_id_eq: 'Neighborhoods',
      placeholder_zoneables_zone_id_eq: 'Zones',
      pnd_basic_placeholder: 'Search by Zones, Neighborhood, Server, Invoicing Firm, Nodes, Plans',
      push_error_message: 'No clients with notifications',
      push_notification_detail: 'Push notification detail',
      push_notification_detail_devices: 'The notification was sent to',
      second_due_date_invoice_push_notification: 'Second Due Date',
      setting_title: 'Configuration of preset notifications',
      status_eq_any: 'Status of the notification',
      time_remaining: 'Will be sent in',
      tooltips: {
        list_of_notification_devices: 'List of Push Potification'
      }
    },
    referral: {
      active_referees: 'Active referees',
      completed: 'Completed',
      conversion_date: 'Converted on',
      created_on: 'Created on',
      debits: 'Total paid',
      lost: 'Lost',
      paid_payments: 'Total credited',
      payment: {
        due: 'Pending',
        due_date: 'Due date',
        lost: 'Lost',
        paid: 'Paid'
      },
      payment_details: 'Payment details',
      referee: 'Referred user',
      referrer: 'Referente',
      tooltip: {
        activation_date: 'Activation date',
        balance: 'Balance to be collected',
        conversion_date: 'Conversion date',
        // created_at: 'Creation date',
        debits: 'Total amount collected',
        no_payment_details: 'No payment details provided',
        paid: 'A credit transaction has been created for this payment',
        paid_payments: 'Total amount credited for this referral to be paid out according to your payment details',
        pending: 'Payments to be collected for this referral'
      },
      transaction_for: 'Transaction for'
    },
    sale_desk: {
      lead: {},
      prospect: {
        no_lead_selected_title: 'No Lead selected',
        no_lead_selected_text: 'Choose one in the Lead input',
        from_unconverted_leads: 'Unconverted leads',
        states: {
          captured: 'Captured',
          converted: 'Converted',
          rejected: 'Rejected',
          deleted: 'Deleted'
        }
      },
      ticket: {
        state: {
          pending: 'Pending',
          pending_order: 'Pending order',
          assigned: 'Assigned',
          finalized: 'Finalized',
          closed: 'Closed',
          reopened: 'Reopened'
        },
        result: 'Result',
        results: {
          success: 'Success',
          failure: 'Failure'
        }
      }
    },
    seal: {
      code: 'Code',
      create_form_preview_title: 'No code to display.',
      create_form_preview_message: 'Add one to preview.',
      create_new_seal: 'Create new Seal',
      has_contracts_filter_both: 'Both',
      has_contracts_filter_with: 'Availables',
      has_contracts_filter_without: 'Occupied',
      limit_seal: 'You have reached the stamp creation limit (1000)',
      placeholder_basic_search: 'You can search by: Code, Nap name.',
      preview: 'Preview',
      sequential_id_gteq: 'ID Seal (From)',
      sequential_id_lteq: 'ID Seal (To)',
      start_end: 'Range(End)',
      start_range: 'Range(Start)'
    },
    search: {
      not_paged: 'Not Paged'
    },
    sent_sms: {
      sent_at_gteq: 'Sent at (Init)',
      sent_at_lteq: 'Sent at (End)'
    },
    server_configuration: {
      allow_only_allowed_contracts_to_navigate: 'Allow only allowed contracts to navigate',
      cable_modem_service_enabled: 'Cable modem service enabled',
      catv_control_enabled: 'CATV Control',
      clamp_mss_to_pmtu: 'Set MSS (maximum transfer unit) according to PMTU (path MTU)',
      default_prio_helpers: 'High priority netfilter helpers (global)',
      default_prio_protos: 'High priority protocols (global)',
      default_tcp_prio_ports: 'High priority TCP ports (global)',
      default_udp_prio_ports: 'High priority UDP ports (global)',
      dns_enabled: 'DNS enabled',
      dns_first_server: 'First DNS Server',
      dns_second_server: 'Second DNS Server',
      dns_server_one: 'Dns Server one',
      dns_server_three: 'Dns Server three',
      dns_server_two: 'Dns Server two',
      equipment_model: 'Model',
      extra_vlans: 'Extra Vlans',
      filter_by_mac_address:
        "Block clients' traffic if their MAC address does not match the one established in the contract",
      firewall_enabled: 'Enable firewall control from Wispro (disables iptables_pre file)',
      firewall_open_tcp_ports: 'Open tcp ports',
      firewall_open_udp_ports: 'Open udp ports',
      gc_thresh1: 'ARP entries (gc_thresh1)',
      gc_thresh2: 'ARP entries (gc_thresh2)',
      gc_thresh3: 'ARP entries (gc_thresh3)',
      host: 'Host',
      in_safe_mode: 'Safe mode',
      interface_graphs_enabled: 'Interface graphs enabled',
      ip_accountig_enabled: 'Contract graphs enabled',
      iptables_tree_optimization_enabled: 'Optimize iptables rules (use only on 64 bits version)',
      lan_interface_ids: 'LAN Interfaces',
      language: 'Language',
      last_changes_applied_at: 'Last changes applied at',
      last_seen_online_at: 'Last time seen online',
      low_latency_for_dns: 'DNS',
      low_latency_for_icmp: 'ICMP',
      low_latency_for_rdp: 'RDP',
      low_latency_for_sip: 'SIP',
      low_latency_for_ssh: 'SSH',
      low_latency_for_tcp_length: 'Package TCP length',
      low_latency_for_udp_length: 'Package UDP length',
      mail_relay_mail: 'Username',
      mail_relay_manipulated_for_sequreisp: 'Manage e-mail configuration with wispro',
      mikrotik_service_branch: 'Mikrotik service branch',
      mikrotik_use_ssl: 'API-SSL',
      mikrotik_www_port: 'WWW service port',
      mtu: 'MTU (maximum transfer unit)',
      navigation_vlan: 'Vlan',
      nf_conntrack_max: 'Maximum number of connections (nf_conntrack_max)',
      not_supported: 'Feature not supported by your version',
      notification_https_block: 'Block and redirection of HTTPS traffic on contracts with notifications',
      ntp_enabled: 'NTP enabled',
      ntp_server_one: 'NTP Server one',
      ntp_server_two: 'NTP Server two',
      olt_wan_provisioning: 'WAN provisioning',
      pass: 'Pass',
      porn_filter_enabled: 'Child pornography filter',
      port: 'API Port',
      profile: 'Profile',
      quantum_factor: 'Bandwidth that represents 1 quantum',
      service_profile: 'Service Profile',
      release_level: 'Release level',
      rx_critical_power_lower: 'RX power critical lower',
      rx_critical_power_upper: 'RX power critical upper',
      rx_warning_power_lower: 'RX power warning lower',
      rx_warning_power_upper: 'RX power warning upper',
      ssh_port: 'SSH Port',
      tc_contracts_per_provider_in_lan: 'Individual contracts tree per provider (LAN)',
      tc_contracts_per_provider_in_wan: 'Individual contracts tree per provider (WAN)',
      tcp_length: 'TCP lenght',
      telnet_port: 'Telnet Port',
      tr069_profile: 'TR069 Profile',
      traffic_capture_enabled: 'Traffic capture enabled',
      traffic_control: 'Bandwidth control',
      traffic_control_enabled: 'Traffic control enabled',
      traffic_prio: 'Priority traffic (low latency)',
      udp_length: 'UDP lenght',
      uniq_contracts_mac_address: 'Check contracts mac_address uniqueness',
      url_notification_redirect: 'URL to redirect after notification',
      use_global_prios: 'Disable per contract priorities and use global priorities instead (experimental)',
      use_global_prios_strategy: 'Guaranteed bandwidth control rules',
      wan_interface_ids: 'WAN Interfaces',
      web_proxy_enabled: 'Web proxy service enabled?',
      web_proxy_port: 'Web proxy port',
      www_ssl_enabled: 'Use www-ssl',
      zoneables_zone_ids: 'Zone'
    },
    service: { dhcp: 'DHCP', pppoe: 'PPPoE', static: 'Static', subnet: 'Subnet' },
    smtp_configuration: {
      address: 'Server Host',
      authentication: 'Authentication mode',
      enable_starttls_auto: 'Auto TLS',
      sender: 'Email (from)',
      sender_password: 'Password'
    },
    source: {
      create_new_source: 'Create new source'
    },
    tag: {
      create_new_tag: 'Create new tag'
    },
    traffic: {
      data_count: 'Data count',
      data_total: 'Data total',
      data_total_extra: 'Data total extra',
      from_date: 'From',
      to_date: 'To'
    },
    tv_services: {
      directv_go: {
        transaction_states: {
          conciliated: 'Conciliated',
          to_authorize: 'To Authorize',
          to_conciliate: 'To Conciliate',
          to_invoice: 'To Invoice'
        },
        subscription_states: {
          active: 'Active',
          inactive: 'Inactive',
          to_inactive: 'Ending Soon'
        }
      }
    },
    user: {
      email: 'User email address',
      last_login_at: 'Last login date',
      last_login_at_never: 'Never',
      last_login_ip: 'IP address of last login',
      last_login_ip_unknown: 'Unknown',
      password_confirmation: 'Password confirmation',
      repeat_password: 'Repeat your password',
      role: 'Role',
      role_ids: 'Roles',
      role_name: 'Permissions',
      unlock_token: 'Unlock Token',
      userable_id: 'Userable ID'
    },
    vat_condition: {
      billing_regime: 'Billing Regime',
      billing_regime_juridical: 'Billing Regime (Business)',
      billing_regime_person: 'Billing Regime (Person)',
      common_regime: 'Common Regime',
      common_regime_juridical: 'Common Regime (Business)',
      common_regime_person: 'Common Regime (Person)',
      exempt: 'Exempt',
      fantasy: 'Fantasy',
      final_consumer: 'Final consumer',
      juridic_person: 'Legal entity',
      natural_person: 'Natural person',
      registered_vat_payer: 'Registered vat payer',
      self_employed_taxpayer: 'Self employed taxpayer',
      simplified_regime: 'Simplified Regime',
      general_regime: 'General Regime of Legal Persons Law',
      legal_entities_with_non_profit_purpose: 'Legal Entities With Non Profit Purpose',
      wages_and_salaries_and_income_assimilated_to_salaries: 'Wages And Salaries And Income Assimilated To Salaries',
      lease: 'Lease',
      property_disposal_or_acquisition_regime: 'Property Disposal Or Acquisition Regime',
      other_income: 'Other Income',
      residents_abroad_without_permanent_establishment_in_mexico:
        'Residents Abroad Without Permanent Establishment In Mexico',
      dividend_income: 'Dividend Income',
      individuals_with_business_and_professional_activities: 'Individuals With Business And Professional Activities',
      interest_income: 'Interest Income',
      income_regime_for_obtaining_prizes: 'Income Regime For Obtaining Prizes',
      no_tax_obligations: 'No Tax Obligations',
      production_cooperative_societies_that_choose_to_defer_their_income:
        'Production Cooperative Societies That Choose To Defer Their Income',
      tax_incorporation: 'Tax Incorporation',
      agricultural_livestock_forestry_and_fishing_activities: 'Agricultural Livestock Forestry And Fishing Activities',
      optional_for_groups_of_companies: 'Optional For Groups Of Companies',
      coordinated: 'Coordinated',
      regime_of_business_activities_with_income_through_technological_platforms:
        'Regime Of Business Activities With Income Through Technological Platforms',
      simplified_trust_regime: 'Simplified Trust Regime'
    },
    vpn_server: {
      ip_from: 'IP from',
      ip_to: 'IP to',
      local_ip: 'Local IP'
    },
    zone: {
      zoneables: 'entities'
    },
    zoneable: {
      zone_id: 'ID',
      zoneable_id: 'ID',
      zoneable_type: 'Type'
    }
  }
};
